import React from 'react';
import '../template-file-css/document-file-template.css';


export const NHBC_PsychosocialAssessment = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='NHBC_PsychosocialAssessment' className='file-pdf-document'>

            <div className='file-template'>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Home Address:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Home Phone Number:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Alternate Contact Number:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtHomeAddress" name="txtHomeAddress" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtPhoneNumber" name="txtPhoneNumber" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtAlternatePhoneNumber" name="txtAlternatePhoneNumber" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Staff Completing the Assessment:</span>
                    <textarea id="txtStaff" name="txtStaff" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Sources of Information:</span>
                </p>
                <p>
                    <input type="checkbox" name="chkSources" id="chkSources" className='add-only' value="Biological Mother/Father" /> Biological Mother/Father &nbsp;
                    <input type="checkbox" name="chkSources1" id="chkSources1" className='add-only' value="Adoptive Mother/Father" /> Adoptive Mother/Father &nbsp;
                    <input type="checkbox" name="chkSources2" id="chkSources2" className='add-only' value="Relative" /> Relative: <input type="text" id="txtRelative" name="txtRelative" className='add-only' /><br />
                    <input type="checkbox" name="chkSources3" id="chkSources3" className='add-only' value="Legal Guardian" /> Legal Guardian<input type="text" id="txtGuardian" name="txtGuardian" className='add-only' />
                    <input type="checkbox" name="chkSources4" id="chkSources4" className='add-only' value="DFCS/DJJ" /> DFCS/DJJ<input type="text" id="txtDfcs" name="txtDfcs" className='add-only' /><br />
                    <input type="checkbox" name="chkSources5" id="chkSources5" className='add-only' value="Other" /> Other:<input type="text" id="txtOther" name="txtOther" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Relatives/Natural Supports:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <strong>Name(s)</strong>
                        </td>
                        <td className='w-250'>
                            <strong>RELATIONSHIP</strong>
                        </td>
                        <td className='w-250'>
                            <strong>CONTACT INFORMATION</strong>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtName" name="txtName" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtRelationship" name="txtRelationship" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtContactInfo" name="txtContactInfo" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtName1" name="txtName1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtRelationship1" name="txtRelationship1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtContactInfo1" name="txtContactInfo1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtName2" name="txtName2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtRelationship2" name="txtRelationship2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtContactInfo2" name="txtContactInfo2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtName3" name="txtName3" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtRelationship3" name="txtRelationship3" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtContactInfo3" name="txtContactInfo3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtName4" name="txtName4" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtRelationship4" name="txtRelationship4" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtContactInfo4" name="txtContactInfo4" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>PRESENTING PROBLEMS
                </h3>
                <p>
                    <span className='eleHeader'>Reason for Referral: PRIMARY REASON(S) FOR SEEKING SERVICES</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkReferral" id="chkReferral" className='add-only' value="Anger Management" /> Anger Management
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkReferral1" id="chkReferral1" className='add-only' value="Anxiety" /> Anxiety
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkReferral2" id="chkReferral2" className='add-only' value="Coping Skills" /> Coping Skills
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkReferral3" id="chkReferral3" className='add-only' value="Depression" /> Depression
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkReferral4" id="chkReferral4" className='add-only' value="Eating Disorder" /> Eating Disorder
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkReferral5" id="chkReferral5" className='add-only' value="Fear Phobias" /> Fear/Phobias
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkReferral6" id="chkReferral6" className='add-only' value="Sexual concerns" /> Sexual concerns
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkReferral7" id="chkReferral7" className='add-only' value="Sleeping Problems" /> Sleeping Problems
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkReferral8" id="chkReferral8" className='add-only' value="Addictive Behaviors" /> Addictive Behaviors
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkReferral9" id="chkReferral9" className='add-only' value="Alcohol Drugs" /> Alcohol/Drugs
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkReferral10" id="chkReferral10" className='add-only' value="Hyperactivity" /> Hyperactivity
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkReferral11" id="chkReferral11" className='add-only' value="ADHD" /> ADHD
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkReferral12" id="chkReferral12" className='add-only' value="PTSD" /> PTSD
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkReferral13" id="chkReferral13" className='add-only' value="Oppositional" /> Oppositional
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkReferral14" id="chkReferral14" className='add-only' value="Truancy" /> Truancy
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkReferral15" id="chkReferral15" className='add-only' value="Running Away" /> Running Away
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkReferral16" id="chkReferral16" className='add-only' value="Hallucinations" /> Hallucinations
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkReferral17" id="chkReferral17" className='add-only' value="Sexual Abuse" /> Sexual Abuse
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkReferral18" id="chkReferral18" className='add-only' value="Physical Abuse" /> Physical Abuse
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkReferral19" id="chkReferral19" className='add-only' value="Emotional Abuse" /> Emotional Abuse
                        </td>
                        <td className='w-250'></td>
                    </tr>
                </table>
                <p>
                    <input type="checkbox" name="chkReferral55" id="chkReferral55" className='add-only' value="Other Mental Health Concerns" /> Other Mental Health Concerns (specify):
                    <textarea id="txtReferral" name="txtReferral" className='add-only'></textarea>
                </p>
                <h3>STRENGTHS
                </h3>
                <p>
                    What are some of the things about your current situation or your surroundings that will assist you in your treatment? Check those that apply and fill in at least one other.
                </p>
                <p>
                    <input type="checkbox" name="chkStrenght" id="chkStrenght" className='add-only' value="Support from my family" /> Support from my family (parents, children, other)
                </p>
                <p>
                    <input type="checkbox" name="chkStrenght1" id="chkStrenght1" className='add-only' value="Support from" /> Support from my spouse or significant other
                </p>
                <p>
                    <input type="checkbox" name="chkStrenght2" id="chkStrenght2" className='add-only' value="Connection to a self" /> Connection to a self-help or advocacy group
                </p>
                <p>
                    <input type="checkbox" name="chkStrenght3" id="chkStrenght3" className='add-only' value="A positive and supportive" /> A positive and supportive sponsor or mentor
                </p>
                <p>
                    <input type="checkbox" name="chkStrenght4" id="chkStrenght4" className='add-only' value="Connection to a church" /> Connection to a church group or minister
                </p>
                <p>
                    <input type="checkbox" name="chkStrenght5" id="chkStrenght5" className='add-only' value="My employer" /> My employer, who helped me get into treatment
                </p>
                <p>
                    <input type="checkbox" name="chkStrenght6" id="chkStrenght6" className='add-only' value="A permanent place to live" /> A permanent place to live
                    Stable home environment
                </p>
                <p>
                    <input type="checkbox" name="chkStrenght7" id="chkStrenght7" className='add-only' value="Other" /> Other
                    <input type="text" id="txtTherapistOther" name="txtTherapistOther" className='add-only' />
                </p>
                <h3>NEEDS
                </h3>
                <p>
                    What are some of the things you believe are necessary in order for you to be successful in completing a program? Check those that apply and fill in at least one other.
                </p>
                <p>
                    <input type="checkbox" name="chkNeeds" id="chkNeeds" className='add-only' value="Education about mental" /> Education about mental Illness
                </p>
                <p>
                    <input type="checkbox" name="chkNeeds1" id="chkNeeds1" className='add-only' value="An explanation of my diagnosis" /> An explanation of my diagnosis
                </p>
                <p>
                    <input type="checkbox" name="chkNeeds2" id="chkNeeds2" className='add-only' value="Improvement in" /> Improvement in my communication skills
                </p>
                <p>
                    <input type="checkbox" name="chkNeeds3" id="chkNeeds3" className='add-only' value="Improvement in my interpersonal" /> Improvement in my interpersonal skills\relationships
                </p>
                <p>
                    <input type="checkbox" name="chkNeeds4" id="chkNeeds4" className='add-only' value="Connection to a self" /> Connection to a self-help or advocacy group
                </p>
                <p>
                    <input type="checkbox" name="chkNeeds5" id="chkNeeds5" className='add-only' value="Help in managing my feelings" /> Help in managing my feelings
                </p>
                <p>
                    <input type="checkbox" name="chkNeeds6" id="chkNeeds6" className='add-only' value="Anger management skills" /> Anger management skills
                </p>
                <p>
                    <input type="checkbox" name="chkNeeds7" id="chkNeeds7" className='add-only' value="Education about effects" /> Education about effects of substance abuse on health
                </p>
                <p>
                    <input type="checkbox" name="chkNeeds8" id="chkNeeds8" className='add-only' value="Education on improving" /> Education on improving my health
                </p>
                <p>
                    <input type="checkbox" name="chkNeeds9" id="chkNeeds9" className='add-only' value="Other" /> Other:
                    <input type="text" id="txtTherapistOther1" name="txtTherapistOther1" className='add-only' />
                </p>
                <h3>ABILITIES
                </h3>
                <p>
                    What are some of your personal qualities, skills and talents that will assist you in your program? Check those that apply and fill in at least one other.
                </p>
                <p>
                    <input type="checkbox" name="chkAbilities" id="chkAbilities" className='add-only' value="I can" /> I can be honest in group discussions
                </p>
                <p>
                    <input type="checkbox" name="chkAbilities1" id="chkAbilities1" className='add-only' value="I am cooperative" /> I am cooperative
                </p>
                <p>
                    <input type="checkbox" name="chkAbilities2" id="chkAbilities2" className='add-only' value="I am willing" /> I am willing to work to grow and change
                </p>
                <p>
                    <input type="checkbox" name="chkAbilities3" id="chkAbilities3" className='add-only' value="I am trustworthy" /> I am trustworthy
                </p>
                <p>
                    <input type="checkbox" name="chkAbilities4" id="chkAbilities4" className='add-only' value="I have faith in God" /> I have faith in God (higher power)
                </p>
                <p>
                    <input type="checkbox" name="chkAbilities5" id="chkAbilities5" className='add-only' value="I have a good" /> I have a good sense of humor
                </p>
                <p>
                    <input type="checkbox" name="chkAbilities6" id="chkAbilities6" className='add-only' value="I have determination" /> I have determination
                </p>
                <p>
                    <input type="checkbox" name="chkAbilities7" id="chkAbilities7" className='add-only' value="I easily share my thought" /> I easily share my thoughts and feelings with others
                </p>
                <p>
                    <input type="checkbox" name="chkAbilities8" id="chkAbilities8" className='add-only' value="I can respect another" /> I can respect another person's privacy
                </p>
                <p>
                    <input type="checkbox" name="chkAbilities9" id="chkAbilities9" className='add-only' value="I am able to ask" /> I am able to ask for help from others
                </p>
                <p>
                    <input type="checkbox" name="chkAbilities11" id="chkAbilities11" className='add-only' value="I can accept and act" /> I can accept and act on advice from others
                </p>
                <p>
                    <input type="checkbox" name="chkAbilities12" id="chkAbilities12" className='add-only' value="I can accept" /> I can accept criticism from others
                </p>
                <p>
                    <input type="checkbox" name="chkAbilities13" id="chkAbilities13" className='add-only' value="I care about my own" /> I care about my own well-being & the well-being of others
                </p>
                <p>
                    <input type="checkbox" name="chkAbilities131" id="chkAbilities131" className='add-only' value="I am able to fulfill" /> I am able to fulfill my program obligations
                </p>
                <p>
                    <input type="checkbox" name="chkAbilities14" id="chkAbilities14" className='add-only' value="Other" /> Other:
                    <input type="text" id="txtTherapistOther3" name="txtTherapistOther3" className='add-only' />
                </p>
                <h3>PREFERENCES
                </h3>
                <p>
                    What are some of your preferences when considering a treatment program?
                </p>
                <p>
                    Which of the following activities would you most like to attend?
                    Check all the apply
                </p>
                <p>
                    <input type="checkbox" name="chkPreferences" id="chkPreferences" className='add-only' value="Group therapy" /> Group therapy
                </p>
                <p>
                    <input type="checkbox" name="chkPreferences1" id="chkPreferences1" className='add-only' value="Education classes" /> Education classes
                </p>
                <p>
                    <input type="checkbox" name="chkPreferences2" id="chkPreferences2" className='add-only' value="Individual therapy" /> Individual therapy sessions
                </p>
                <p>
                    <input type="checkbox" name="chkPreferences3" id="chkPreferences3" className='add-only' value="Family Education" /> Family Education and Support
                </p>
                <p>
                    <input type="checkbox" name="chkPreferences4" id="chkPreferences4" className='add-only' value="Couples counseling" /> Couples counseling
                </p>
                <p>
                    <input type="checkbox" name="chkPreferences5" id="chkPreferences5" className='add-only' value="AA" /> AA, NA or Al-anon
                </p>
                <p>
                    <input type="checkbox" name="chkPreferences6" id="chkPreferences6" className='add-only' value="Mental health counseling" /> Mental health counseling
                </p>
                <p>
                    <input type="checkbox" name="chkPreferences7" id="chkPreferences7" className='add-only' value="Community Supports" /> Community Supports/Case Management Services
                </p>
                <p>
                    <span className='eleHeader'>What are some issues specific in your life that you wish to address while in treatment?</span>
                </p>
                <p>
                    1.<textarea id="txtPreferences2" name="txtPreferences2" className='add-only'></textarea>
                </p>
                <p>
                    2.<textarea id="txtPreferences1" name="txtPreferences1" className='add-only'></textarea>
                </p>
                <h3>DESIRED OUTCOMES
                </h3>
                <p>
                    What are the expectations you have about coming here today? In other words, what would you like to accomplish?
                </p>
                <p>
                    <input type="checkbox" name="chkOutcomes1" id="chkOutcomes1" className='add-only' value="I will learn" /> I will learn skills to manage my symptoms
                </p>
                <p>
                    <input type="checkbox" name="chkOutcomes2" id="chkOutcomes2" className='add-only' value="I will understand" />
                    I will understand why I need to take my medication
                </p>
                <p>
                    <input type="checkbox" name="chkOutcomes3" id="chkOutcomes3" className='add-only' value="I will be able to communicat" />
                    I will be able to communicate more effectively
                </p>
                <p>
                    <input type="checkbox" name="chkOutcomes4" id="chkOutcomes4" className='add-only' value="My interpersonal" />
                    My interpersonal skills/relationships will improve
                </p>
                <p>
                    <input type="checkbox" name="chkOutcomes5" id="chkOutcomes5" className='add-only' value="I will develop" />
                    I will develop a system of support and recovery
                </p>
                <p>
                    <input type="checkbox" name="chkOutcomes6" id="chkOutcomes6" className='add-only' value="I will be able to " />
                    I will be able to manage my feelings
                </p>
                <p>
                    <input type="checkbox" name="chkOutcomes7" id="chkOutcomes7" className='add-only' value="I will be able to manage my anger" />
                    I will be able to manage my anger
                </p>
                <p>
                    <input type="checkbox" name="chkOutcomes8" id="chkOutcomes8" className='add-only' value="My health will improve" /> My health will improve
                </p>
                <p>
                    <input type="checkbox" name="chkOutcomes9" id="chkOutcomes9" className='add-only' value="I will have an understanding" /> I will have an understanding of relapse prevention
                </p>
                <p>
                    <input type="checkbox" name="chkOutcomes11" id="chkOutcomes11" className='add-only' value="Other" /> Other
                    <input type="text" id="txtTherapistOther31" name="txtTherapistOther31" className='add-only' />
                </p>
                <h3>FAMILY INFORMATION
                </h3>
                <p>
                    <span className='eleHeader'>Current Living Situation</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkLivSituation" id="chkLivSituation" className='add-only' value="In home with biological" /> In home with biological parents
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkLivSituation1" id="chkLivSituation1" className='add-only' value="Youth Development Center" /> Youth Development Center (YDC)
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkLivSituation2" id="chkLivSituation2" className='add-only' value="Relatives" /> Relatives
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkLivSituation3" id="chkLivSituation3" className='add-only' value="Foster Home" /> Foster Home
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkLivSituation4" id="chkLivSituation4" className='add-only' value="In a shelter" /> In a shelter
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkLivSituation5" id="chkLivSituation5" className='add-only' value="Group Home" />Group Home
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" name="chkLivSituation6" id="chkLivSituation6" className='add-only' value="Psychiatric Residential Treatment Facility" />Psychiatric Residential Treatment Facility (PRTF)
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" name="chkLivSituation7" id="chkLivSituation7" className='add-only' value="With non" />With non-custodial parent or guardian
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" name="chkLivSituation8" id="chkLivSituation8" className='add-only' value="Regional Youth" />Regional Youth Detention Center (RYDC)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkLivSituation9" id="chkLivSituation9" className='add-only' value="Homeless" />Homeless, not in a shelter
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkLivSituation11" id="chkLivSituation11" className='add-only' value="In a shelter" />County Jail
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkLivSituation12" id="chkLivSituation12" className='add-only' value="Other" />Other:
                            <input type="text" id="txtLivSituation" name="txtLivSituation" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>List all others living in your family home.</span>
                </p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <strong>Name</strong>
                        </td>
                        <td className='w-100'>
                            <strong>Age</strong>
                        </td>
                        <td className='w-250'>
                            <strong>Relationship to Child</strong>
                        </td>
                        <td className='w-250'>
                            <strong>Quality of Relationship</strong>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtFamilyName" name="txtFamilyName" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtFamilyAge" name="txtFamilyAge" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtFamilyRelationship" name="txtFamilyRelationship" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtFamilyQuality" name="txtFamilyQuality" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtFamilyName1" name="txtFamilyName1" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtFamilyAge1" name="txtFamilyAge1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtFamilyRelationship1" name="txtFamilyRelationship1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtFamilyQuality1" name="txtFamilyQuality1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtFamilyName2" name="txtFamilyName2" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtFamilyAge2" name="txtFamilyAge2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtFamilyRelationship2" name="txtFamilyRelationship2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtFamilyQuality2" name="txtFamilyQuality2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtFamilyName3" name="txtFamilyName3" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtFamilyAge3" name="txtFamilyAge3" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtFamilyRelationship3" name="txtFamilyRelationship3" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtFamilyQuality3" name="txtFamilyQuality3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtFamilyName4" name="txtFamilyName4" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtFamilyAge4" name="txtFamilyAge4" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtFamilyRelationship4" name="txtFamilyRelationship4" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtFamilyQuality4" name="txtFamilyQuality4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtFamilyName5" name="txtFamilyName5" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtFamilyAge5" name="txtFamilyAge5" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtFamilyRelationship5" name="txtFamilyRelationship5" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtFamilyQuality5" name="txtFamilyQuality5" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Is there a non-custodial parent</span>
                    <input type="radio" id="rbParent_Yes" name="rbParent" className='add-only' value="1" />  Yes &nbsp;
                    <input type="radio" id="rbParent_No" name="rbParent" className='add-only' value="0" />  No
                </p>
                <p>
                    If so, describe the involvement on the part of that parent. (Include info on visitation, child support, etc.; describe family relationships & desire for involvement in the treatment process:
                    <textarea id="txtParent" name="txtParent" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Client's perception of family support:</span>
                    <input type="radio" id="rbSupport_Yes" name="rbSupport" className='add-only' value="1" />  Very supportive &nbsp;
                    <input type="radio" id="rbSupport_No" name="rbSupport" className='add-only' value="0" />  Somewhat supportive &nbsp;
                    <input type="radio" id="rbSupport_NA" name="rbSupport" className='add-only' value="2" />  Unsupportive
                </p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>Family History of (Check all that apply)</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>Mother</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>Father</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>Siblings</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>Aunt</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>Uncle</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>Grandparents</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>  <b>Alcohol/Substance Abuse</b></td>
                        <td className='w-100'>
                            <input type="radio" name="rbMotherNatural_1" id="rbMother_1" className='add-only' value="Natural" /> Natural &nbsp; <br />
                            <input type="radio" name="rbMotherStep_1" id="rbMother_1" className='add-only' value="Step" /> Step
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbFatherNatural_1" id="rbFather_1" className='add-only' value="Natural" /> Natural &nbsp; <br />
                            <input type="radio" name="rbFatherStep_1" id="rbFather_1" className='add-only' value="Step" /> Step
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbSiblingsBro_1" id="rbSiblings_1" className='add-only' value="Brother" /> Brother &nbsp; <br />
                            <input type="radio" name="rbSiblingsSis_1" id="rbSiblings_1" className='add-only' value="Sister" /> Sister
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbAuntPat_1" id="rbAunt_1" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbAuntMat_1" id="rbAunt_1" className='add-only' value="Maternal" /> Maternal
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbUnclePat_1" id="rbUncle_1" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbUncleMat_1" id="rbUncle_1" className='add-only' value="Maternal" /> Maternal
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbGrandparentsPat_1" id="rbGrandparents_1" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbGrandparentsMat_1" id="rbGrandparents_1" className='add-only' value="Maternal" /> Maternal
                        </td>
                    </tr>
                    <tr> <td className='w-750'>  <hr></hr> </td>   </tr>

                    <tr>
                        <td className='w-150'>  <b>History of Suicide</b></td>
                        <td className='w-100'>
                            <input type="radio" name="rbMotherNatural_2" id="rbMother_2" className='add-only' value="Natural" /> Natural &nbsp; <br />
                            <input type="radio" name="rbMotherStep_2" id="rbMother_2" className='add-only' value="Step" /> Step
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbFatherNatural_2" id="rbFather_2" className='add-only' value="Natural" /> Natural &nbsp; <br />
                            <input type="radio" name="rbFatherStep_2" id="rbFather_2" className='add-only' value="Step" /> Step
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbSiblingsBro_2" id="rbSiblings_2" className='add-only' value="Brother" /> Brother &nbsp; <br />
                            <input type="radio" name="rbSiblingsSis_2" id="rbSiblings_2" className='add-only' value="Sister" /> Sister
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbAuntPat_2" id="rbAunt_2" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbAuntMat_2" id="rbAunt_2" className='add-only' value="Maternal" /> Maternal
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbUnclePat_2" id="rbUncle_2" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbUncleMat_2" id="rbUncle_2" className='add-only' value="Maternal" /> Maternal
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbGrandparentsPat_2" id="rbGrandparents_2" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbGrandparentsMat_2" id="rbGrandparents_2" className='add-only' value="Maternal" /> Maternal
                        </td>
                    </tr>
                    <tr> <td className='w-750'>  <hr></hr> </td>   </tr>

                    <tr>
                        <td className='w-150'>  <b>History of Mental Illness/Problems Such as:</b></td>
                        <td className='w-100'>
                            <input type="radio" name="rbMotherNatural_3" id="rbMother_3" className='add-only' value="Natural" /> Natural &nbsp; <br />
                            <input type="radio" name="rbMotherStep_3" id="rbMother_3" className='add-only' value="Step" /> Step
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbFatherNatural_3" id="rbFather_3" className='add-only' value="Natural" /> Natural &nbsp; <br />
                            <input type="radio" name="rbFatherStep_3" id="rbFather_3" className='add-only' value="Step" /> Step
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbSiblingsBro_3" id="rbSiblings_3" className='add-only' value="Brother" /> Brother &nbsp; <br />
                            <input type="radio" name="rbSiblingsSis_3" id="rbSiblings_3" className='add-only' value="Sister" /> Sister
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbAuntPat_3" id="rbAunt_3" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbAuntMat_3" id="rbAunt_3" className='add-only' value="Maternal" /> Maternal
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbUnclePat_3" id="rbUncle_3" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbUncleMat_3" id="rbUncle_3" className='add-only' value="Maternal" /> Maternal
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbGrandparentsPat_3" id="rbGrandparents_3" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbGrandparentsMat_3" id="rbGrandparents_3" className='add-only' value="Maternal" /> Maternal
                        </td>
                    </tr>
                    <tr> <td className='w-750'>  <hr></hr> </td>   </tr>

                    <tr>
                        <td className='w-150'>  <b>Depression</b></td>
                        <td className='w-100'>
                            <input type="radio" name="rbMotherNatural_4" id="rbMother_4" className='add-only' value="Natural" /> Natural &nbsp; <br />
                            <input type="radio" name="rbMotherStep_4" id="rbMother_4" className='add-only' value="Step" /> Step
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbFatherNatural_4" id="rbFather_4" className='add-only' value="Natural" /> Natural &nbsp; <br />
                            <input type="radio" name="rbFatherStep_4" id="rbFather_4" className='add-only' value="Step" /> Step
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbSiblingsBro_4" id="rbSiblings_4" className='add-only' value="Brother" /> Brother &nbsp; <br />
                            <input type="radio" name="rbSiblingsSis_4" id="rbSiblings_4" className='add-only' value="Sister" /> Sister
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbAuntPat_4" id="rbAunt_4" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbAuntMat_4" id="rbAunt_4" className='add-only' value="Maternal" /> Maternal
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbUnclePat_4" id="rbUncle_4" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbUncleMat_4" id="rbUncle_4" className='add-only' value="Maternal" /> Maternal
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbGrandparentsPat_4" id="rbGrandparents_4" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbGrandparentsMat_4" id="rbGrandparents_4" className='add-only' value="Maternal" /> Maternal
                        </td>
                    </tr>
                    <tr> <td className='w-750'>  <hr></hr> </td>   </tr>

                    <tr>
                        <td className='w-150'>  <b>Schizophrenia</b></td>
                        <td className='w-100'>
                            <input type="radio" name="rbMotherNatural_5" id="rbMother_5" className='add-only' value="Natural" /> Natural &nbsp; <br />
                            <input type="radio" name="rbMotherStep_5" id="rbMother_5" className='add-only' value="Step" /> Step
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbFatherNatural_5" id="rbFather_5" className='add-only' value="Natural" /> Natural &nbsp; <br />
                            <input type="radio" name="rbFatherStep_5" id="rbFather_5" className='add-only' value="Step" /> Step
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbSiblingsBro_5" id="rbSiblings_5" className='add-only' value="Brother" /> Brother &nbsp; <br />
                            <input type="radio" name="rbSiblingsSis_5" id="rbSiblings_5" className='add-only' value="Sister" /> Sister
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbAuntPat_5" id="rbAunt_5" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbAuntMat_5" id="rbAunt_5" className='add-only' value="Maternal" /> Maternal
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbUnclePat_5" id="rbUncle_5" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbUncleMat_5" id="rbUncle_5" className='add-only' value="Maternal" /> Maternal
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbGrandparentsPat_5" id="rbGrandparents_5" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbGrandparentsMat_5" id="rbGrandparents_5" className='add-only' value="Maternal" /> Maternal
                        </td>
                    </tr>
                    <tr> <td className='w-750'>  <hr></hr> </td>   </tr>

                    <tr>
                        <td className='w-150'>  <b> Bipolar Disorder</b></td>
                        <td className='w-100'>
                            <input type="radio" name="rbMotherNatural_6" id="rbMother_6" className='add-only' value="Natural" /> Natural &nbsp; <br />
                            <input type="radio" name="rbMotherStep_6" id="rbMother_6" className='add-only' value="Step" /> Step
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbFatherNatural_6" id="rbFather_6" className='add-only' value="Natural" /> Natural &nbsp; <br />
                            <input type="radio" name="rbFatherStep_6" id="rbFather_6" className='add-only' value="Step" /> Step
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbSiblingsBro_6" id="rbSiblings_6" className='add-only' value="Brother" /> Brother &nbsp; <br />
                            <input type="radio" name="rbSiblingsSis_6" id="rbSiblings_6" className='add-only' value="Sister" /> Sister
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbAuntPat_6" id="rbAunt_6" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbAuntMat_6" id="rbAunt_6" className='add-only' value="Maternal" /> Maternal
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbUnclePat_6" id="rbUncle_6" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbUncleMat_6" id="rbUncle_6" className='add-only' value="Maternal" /> Maternal
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbGrandparentsPat_6" id="rbGrandparents_6" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbGrandparentsMat_6" id="rbGrandparents_6" className='add-only' value="Maternal" /> Maternal
                        </td>
                    </tr>
                    <tr> <td className='w-750'>  <hr></hr> </td>   </tr>

                    <tr>
                        <td className='w-150'>  <b>Alzheimer's</b></td>
                        <td className='w-100'>
                            <input type="radio" name="rbMotherNatural_7" id="rbMother_7" className='add-only' value="Natural" /> Natural &nbsp; <br />
                            <input type="radio" name="rbMotherStep_7" id="rbMother_7" className='add-only' value="Step" /> Step
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbFatherNatural_7" id="rbFather_7" className='add-only' value="Natural" /> Natural &nbsp; <br />
                            <input type="radio" name="rbFatherStep_7" id="rbFather_7" className='add-only' value="Step" /> Step
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbSiblingsBro_7" id="rbSiblings_7" className='add-only' value="Brother" /> Brother &nbsp; <br />
                            <input type="radio" name="rbSiblingsSis_7" id="rbSiblings_7" className='add-only' value="Sister" /> Sister
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbAuntPat_7" id="rbAunt_7" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbAuntMat_7" id="rbAunt_7" className='add-only' value="Maternal" /> Maternal
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbUnclePat_7" id="rbUncle_7" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbUncleMat_7" id="rbUncle_7" className='add-only' value="Maternal" /> Maternal
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbGrandparentsPat_7" id="rbGrandparents_7" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbGrandparentsMat_7" id="rbGrandparents_7" className='add-only' value="Maternal" /> Maternal
                        </td>
                    </tr>
                    <tr> <td className='w-750'>  <hr></hr> </td>   </tr>

                    <tr>
                        <td className='w-150'>  <b>Anxiety</b></td>
                        <td className='w-100'>
                            <input type="radio" name="rbMotherNatural_8" id="rbMother_8" className='add-only' value="Natural" /> Natural &nbsp; <br />
                            <input type="radio" name="rbMotherStep_8" id="rbMother_8" className='add-only' value="Step" /> Step
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbFatherNatural_8" id="rbFather_8" className='add-only' value="Natural" /> Natural &nbsp; <br />
                            <input type="radio" name="rbFatherStep_8" id="rbFather_8" className='add-only' value="Step" /> Step
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbSiblingsBro_8" id="rbSiblings_8" className='add-only' value="Brother" /> Brother &nbsp; <br />
                            <input type="radio" name="rbSiblingsSis_8" id="rbSiblings_8" className='add-only' value="Sister" /> Sister
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbAuntPat_8" id="rbAunt_8" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbAuntMat_8" id="rbAunt_8" className='add-only' value="Maternal" /> Maternal
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbUnclePat_8" id="rbUncle_8" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbUncleMat_8" id="rbUncle_8" className='add-only' value="Maternal" /> Maternal
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbGrandparentsPat_8" id="rbGrandparents_8" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbGrandparentsMat_8" id="rbGrandparents_8" className='add-only' value="Maternal" /> Maternal
                        </td>
                    </tr>
                    <tr> <td className='w-750'>  <hr></hr> </td>   </tr>

                    <tr>
                        <td className='w-150'>  <b> Attention Deficit/ Hyperactivity </b></td>
                        <td className='w-100'>
                            <input type="radio" name="rbMotherNatural_9" id="rbMother_9" className='add-only' value="Natural" /> Natural &nbsp; <br />
                            <input type="radio" name="rbMotherStep_9" id="rbMother_9" className='add-only' value="Step" /> Step
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbFatherNatural_9" id="rbFather_9" className='add-only' value="Natural" /> Natural &nbsp; <br />
                            <input type="radio" name="rbFatherStep_9" id="rbFather_9" className='add-only' value="Step" /> Step
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbSiblingsBro_9" id="rbSiblings_9" className='add-only' value="Brother" /> Brother &nbsp; <br />
                            <input type="radio" name="rbSiblingsSis_9" id="rbSiblings_9" className='add-only' value="Sister" /> Sister
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbAuntPat_9" id="rbAunt_9" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbAuntMat_9" id="rbAunt_9" className='add-only' value="Maternal" /> Maternal
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbUnclePat_9" id="rbUncle_9" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbUncleMat_9" id="rbUncle_9" className='add-only' value="Maternal" /> Maternal
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbGrandparentsPat_9" id="rbGrandparents_9" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbGrandparentsMat_9" id="rbGrandparents_9" className='add-only' value="Maternal" /> Maternal
                        </td>
                    </tr>
                    <tr> <td className='w-750'>  <hr></hr> </td>   </tr>

                    <tr>
                        <td className='w-150'>  <b> Learning Disorders</b></td>
                        <td className='w-100'>
                            <input type="radio" name="rbMotherNatural_10" id="rbMother_10" className='add-only' value="Natural" /> Natural &nbsp; <br />
                            <input type="radio" name="rbMotherStep_10" id="rbMother_10" className='add-only' value="Step" /> Step
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbFatherNatural_10" id="rbFather_10" className='add-only' value="Natural" /> Natural &nbsp; <br />
                            <input type="radio" name="rbFatherStep_10" id="rbFather_10" className='add-only' value="Step" /> Step
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbSiblingsBro_10" id="rbSiblings_10" className='add-only' value="Brother" /> Brother &nbsp; <br />
                            <input type="radio" name="rbSiblingsSis_10" id="rbSiblings_10" className='add-only' value="Sister" /> Sister
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbAuntPat_10" id="rbAunt_10" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbAuntMat_10" id="rbAunt_10" className='add-only' value="Maternal" /> Maternal
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbUnclePat_10" id="rbUncle_10" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbUncleMat_10" id="rbUncle_10" className='add-only' value="Maternal" /> Maternal
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbGrandparentsPat_10" id="rbGrandparents_10" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbGrandparentsMat_10" id="rbGrandparents_10" className='add-only' value="Maternal" /> Maternal
                        </td>
                    </tr>
                    <tr> <td className='w-750'>  <hr></hr> </td>   </tr>

                    <tr>
                        <td className='w-150'>  <b> School Behavior Problems</b></td>
                        <td className='w-100'>
                            <input type="radio" name="rbMotherNatural_11" id="rbMother_11" className='add-only' value="Natural" /> Natural &nbsp; <br />
                            <input type="radio" name="rbMotherStep_11" id="rbMother_11" className='add-only' value="Step" /> Step
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbFatherNatural_11" id="rbFather_11" className='add-only' value="Natural" /> Natural &nbsp; <br />
                            <input type="radio" name="rbFatherStep_11" id="rbFather_11" className='add-only' value="Step" /> Step
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbSiblingsBro_11" id="rbSiblings_11" className='add-only' value="Brother" /> Brother &nbsp; <br />
                            <input type="radio" name="rbSiblingsSis_11" id="rbSiblings_11" className='add-only' value="Sister" /> Sister
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbAuntPat_11" id="rbAunt_11" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbAuntMat_11" id="rbAunt_11" className='add-only' value="Maternal" /> Maternal
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbUnclePat_11" id="rbUncle_11" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbUncleMat_11" id="rbUncle_11" className='add-only' value="Maternal" /> Maternal
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbGrandparentsPat_11" id="rbGrandparents_11" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbGrandparentsMat_11" id="rbGrandparents_11" className='add-only' value="Maternal" /> Maternal
                        </td>
                    </tr>
                    <tr> <td className='w-750'>  <hr></hr> </td>   </tr>

                    <tr>
                        <td className='w-150'>  <b>Incarceration</b></td>
                        <td className='w-100'>
                            <input type="radio" name="rbMotherNatural_12" id="rbMother_12" className='add-only' value="Natural" /> Natural &nbsp; <br />
                            <input type="radio" name="rbMotherStep_12" id="rbMother_12" className='add-only' value="Step" /> Step
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbFatherNatural_12" id="rbFather_12" className='add-only' value="Natural" /> Natural &nbsp; <br />
                            <input type="radio" name="rbFatherStep_12" id="rbFather_12" className='add-only' value="Step" /> Step
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbSiblingsBro_12" id="rbSiblings_12" className='add-only' value="Brother" /> Brother &nbsp; <br />
                            <input type="radio" name="rbSiblingsSis_12" id="rbSiblings_12" className='add-only' value="Sister" /> Sister
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbAuntPat_12" id="rbAunt_12" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbAuntMat_12" id="rbAunt_12" className='add-only' value="Maternal" /> Maternal
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbUnclePat_12" id="rbUncle_12" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbUncleMat_12" id="rbUncle_12" className='add-only' value="Maternal" /> Maternal
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbGrandparentsPat_12" id="rbGrandparents_12" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbGrandparentsMat_12" id="rbGrandparents_12" className='add-only' value="Maternal" /> Maternal
                        </td>
                    </tr>
                    <tr> <td className='w-750'>  <hr></hr> </td>   </tr>

                    <tr>
                        <td className='w-150'>  <b> Sexual Offending</b></td>
                        <td className='w-100'>
                            <input type="radio" name="rbMotherNatural_13" id="rbMother_13" className='add-only' value="Natural" /> Natural &nbsp; <br />
                            <input type="radio" name="rbMotherStep_13" id="rbMother_13" className='add-only' value="Step" /> Step
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbFatherNatural_13" id="rbFather_13" className='add-only' value="Natural" /> Natural &nbsp; <br />
                            <input type="radio" name="rbFatherStep_13" id="rbFather_13" className='add-only' value="Step" /> Step
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbSiblingsBro_13" id="rbSiblings_13" className='add-only' value="Brother" /> Brother &nbsp; <br />
                            <input type="radio" name="rbSiblingsSis_13" id="rbSiblings_13" className='add-only' value="Sister" /> Sister
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbAuntPat_13" id="rbAunt_13" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbAuntMat_13" id="rbAunt_13" className='add-only' value="Maternal" /> Maternal
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbUnclePat_13" id="rbUncle_13" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbUncleMat_13" id="rbUncle_13" className='add-only' value="Maternal" /> Maternal
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbGrandparentsPat_13" id="rbGrandparents_13" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbGrandparentsMat_13" id="rbGrandparents_13" className='add-only' value="Maternal" /> Maternal
                        </td>
                    </tr>
                    <tr> <td className='w-750'>  <hr></hr> </td>   </tr>

                    <tr>
                        <td className='w-150'>  <b> Domestic Violence </b></td>
                        <td className='w-100'>
                            <input type="radio" name="rbMotherNatural_14" id="rbMother_14" className='add-only' value="Natural" /> Natural &nbsp; <br />
                            <input type="radio" name="rbMotherStep_14" id="rbMother_14" className='add-only' value="Step" /> Step
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbFatherNatural_14" id="rbFather_14" className='add-only' value="Natural" /> Natural &nbsp; <br />
                            <input type="radio" name="rbFatherStep_14" id="rbFather_14" className='add-only' value="Step" /> Step
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbSiblingsBro_14" id="rbSiblings_14" className='add-only' value="Brother" /> Brother &nbsp; <br />
                            <input type="radio" name="rbSiblingsSis_14" id="rbSiblings_14" className='add-only' value="Sister" /> Sister
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbAuntPat_14" id="rbAunt_14" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbAuntMat_14" id="rbAunt_14" className='add-only' value="Maternal" /> Maternal
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbUnclePat_14" id="rbUncle_14" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbUncleMat_14" id="rbUncle_14" className='add-only' value="Maternal" /> Maternal
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbGrandparentsPat_14" id="rbGrandparents_14" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbGrandparentsMat_14" id="rbGrandparents_14" className='add-only' value="Maternal" /> Maternal
                        </td>
                    </tr>
                    <tr> <td className='w-750'>  <hr></hr> </td>   </tr>

                    <tr>
                        <td className='w-150'>  <b>Unemployment</b></td>
                        <td className='w-100'>
                            <input type="radio" name="rbMotherNatural_15" id="rbMother_15" className='add-only' value="Natural" /> Natural &nbsp; <br />
                            <input type="radio" name="rbMotherStep_15" id="rbMother_15" className='add-only' value="Step" /> Step
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbFatherNatural_15" id="rbFather_15" className='add-only' value="Natural" /> Natural &nbsp; <br />
                            <input type="radio" name="rbFatherStep_15" id="rbFather_15" className='add-only' value="Step" /> Step
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbSiblingsBro_15" id="rbSiblings_15" className='add-only' value="Brother" /> Brother &nbsp; <br />
                            <input type="radio" name="rbSiblingsSis_15" id="rbSiblings_15" className='add-only' value="Sister" /> Sister
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbAuntPat_15" id="rbAunt_15" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbAuntMat_15" id="rbAunt_15" className='add-only' value="Maternal" /> Maternal
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbUnclePat_15" id="rbUncle_15" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbUncleMat_15" id="rbUncle_15" className='add-only' value="Maternal" /> Maternal
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbGrandparentsPat_15" id="rbGrandparents_15" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbGrandparentsMat_15" id="rbGrandparents_15" className='add-only' value="Maternal" /> Maternal
                        </td>
                    </tr>
                    <tr> <td className='w-750'>  <hr></hr> </td>   </tr>

                    <tr>
                        <td className='w-150'>  <b>other:</b></td>
                        <td className='w-100'>
                            <input type="radio" name="rbMotherNatural_16" id="rbMother_16" className='add-only' value="Natural" /> Natural &nbsp; <br />
                            <input type="radio" name="rbMotherStep_16" id="rbMother_16" className='add-only' value="Step" /> Step
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbFatherNatural_16" id="rbFather_16" className='add-only' value="Natural" /> Natural &nbsp; <br />
                            <input type="radio" name="rbFatherStep_16" id="rbFather_16" className='add-only' value="Step" /> Step
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbSiblingsBro_16" id="rbSiblings_16" className='add-only' value="Brother" /> Brother &nbsp; <br />
                            <input type="radio" name="rbSiblingsSis_16" id="rbSiblings_16" className='add-only' value="Sister" /> Sister
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbAuntPat_16" id="rbAunt_16" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbAuntMat_16" id="rbAunt_16" className='add-only' value="Maternal" /> Maternal
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbUnclePat_16" id="rbUncle_16" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbUncleMat_16" id="rbUncle_16" className='add-only' value="Maternal" /> Maternal
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbGrandparentsPat_16" id="rbGrandparents_16" className='add-only' value="Paternal" /> Paternal &nbsp; <br />
                            <input type="radio" name="rbGrandparentsMat_16" id="rbGrandparents_16" className='add-only' value="Maternal" /> Maternal
                        </td>
                    </tr>
                    <tr> <td className='w-750'>  <hr></hr> </td>   </tr>

                </table>





                <p>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id="txtComments" name="txtComments" className='add-only'></textarea>
                </p>
                <h3>CONSUMER INFORMATION:
                </h3>
                <h4>Child/Adolescent Growth & Development
                </h4>
                <p>
                    <span className='eleHeader'>During pregnancy, did the biological mother have any of the following </span><span className="small"> (check all that apply)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAdolescent" id="chkAdolescent" className='add-only' value="Amniocentesis" /> Amniocentesis
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAdolescent1" id="chkAdolescent1" className='add-only' value="Anemia" /> Anemia
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAdolescent2" id="chkAdolescent2" className='add-only' value="Diabetes Mellitus" /> Diabetes Mellitus
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAdolescent3" id="chkAdolescent3" className='add-only' value="Emotional Problems" /> Emotional Problems
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAdolescent4" id="chkAdolescent4" className='add-only' value="Excessive weight gain" /> Excessive weight gain
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAdolescent5" id="chkAdolescent5" className='add-only' value="German Measles" /> German Measles
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAdolescent6" id="chkAdolescent6" className='add-only' value="High Blood Pressure" /> High Blood Pressure
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAdolescent7" id="chkAdolescent7" className='add-only' value="High Fever" /> High Fever
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAdolescent8" id="chkAdolescent8" className='add-only' value="German Measles" /> Kidney problems
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAdolescent9" id="chkAdolescent9" className='add-only' value="No Prenatal Care" /> No Prenatal Care
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAdolescent11" id="chkAdolescent11" className='add-only' value="Placenta Previa" /> Placenta Previa
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAdolescent12" id="chkAdolescent12" className='add-only' value="Premature labor" /> Premature labor
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAdolescent13" id="chkAdolescent13" className='add-only' value="Vaginal Bleeding" /> Vaginal Bleeding
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAdolescent14" id="chkAdolescent14" className='add-only' value="Vaginal Infection" /> Vaginal Infection
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAdolescent15" id="chkAdolescent15" className='add-only' value="Other Infection" /> Other Infection
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAdolescent16" id="chkAdolescent16" className='add-only' value="Vaginal Bleeding" /> Unknown
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type="checkbox" name="chkAdolescent17" id="chkAdolescent17" className='add-only' value="Vaginal Infection" /> Other:
                            <input type="text" id="txtAdolescent" name="txtAdolescent" className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>During Pregnancy, did the mother use any of the following:</span>
                    <input type="radio" id="rbPregnancy_Yes" name="rbPregnancy" className='add-only' value="1" /> Tobacco &nbsp;
                    <input type="radio" id="rbPregnancy_No" name="rbPregnancy" className='add-only' value="0" /> Alcohol &nbsp;
                    <input type="radio" id="rbPregnancy_Na" name="rbPregnancy" className='add-only' value="2" /> Drugs &nbsp;
                    <input type="radio" id="rbPregnancy_Ns" name="rbPregnancy" className='add-only' value="3" /> Unknown
                </p>
                <p>
                    <span className='eleHeader'>Comments </span>
                    <span className='small'>(frequency and intensity of use, participation in treatment, birth defects or malformations due to drug/alcohol use among siblings):</span>
                    <textarea id="txtComments11" name="txtComments11" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Developmental Milestones</span>
                    <span className='small'>(Please select any that the client did late or is still having trouble with):</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkMilestones" id="chkMilestones" className='add-only' value="Rolling Over" />Rolling Over
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkMilestones1" id="chkMilestones1" className='add-only' value="Sitting" />Sitting (6-12 months)
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkMilestones2" id="chkMilestones2" className='add-only' value="Standing" />Standing (8-16 months)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkMilestones3" id="chkMilestones3" className='add-only' value="Walking" />Walking (8-16 months)
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkMilestones4" id="chkMilestones4" className='add-only' value="Engaging" />Engaging peers (24-36 months)
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkMilestones5" id="chkMilestones5" className='add-only' value="Toileting" />Toileting (24-36 months)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkMilestones6" id="chkMilestones6" className='add-only' value="Dressing" />Dressing Self (24-36 months)
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkMilestones7" id="chkMilestones7" className='add-only' value="Feeding Self" />Feeding Self
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkMilestones8" id="chkMilestones8" className='add-only' value="Sleeping Alone" />Sleeping Alone
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkMilestones9" id="chkMilestones9" className='add-only' value="Tolerating Separation" />Tolerating Separation
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkMilestones11" id="chkMilestones11" className='add-only' value="Playing Cooperatively" />Playing Cooperatively
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkMilestones12" id="chkMilestones12" className='add-only' value="Speaking" />Speaking
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Developmental History Unknown</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Immunizations up to date?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rbDevelopmental_Yes" name="rbDevelopmental" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbDevelopmental_No" name="rbDevelopmental" className='add-only' value="0" /> No
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rbDevelopmental1_Yes" name="rbDevelopmental1" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbDevelopmental1_No" name="rbDevelopmental1" className='add-only' value="0" /> No
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Has the client had any of the following? </span><span className='small'>(check all that apply)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Blood Disorders:</span>  </td>
                    </tr>
                    <tr>
                        <td className='w-187'> <input type="checkbox" name="cbBloodDisorders_1" id="cbBloodDisorders_1" className='add-only' value="1" /> Anemia </td>
                        <td className='w-187'> <input type="checkbox" name="cbBloodDisorders_2" id="cbBloodDisorders_2" className='add-only' value="2" /> Bleeding </td>
                        <td className='w-187'> <input type="checkbox" name="cbBloodDisorders_3" id="cbBloodDisorders_3" className='add-only' value="3" /> Bruising </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Brain Disorders:</span>  </td>
                    </tr>
                    <tr>
                        <td className='w-187'> <input type="checkbox" name="cbBrainDisorders_1" id="cbBrainDisorders_1" className='add-only' value="1" /> Confusion </td>
                        <td className='w-187'> <input type="checkbox" name="cbBrainDisorders_2" id="cbBrainDisorders_2" className='add-only' value="2" /> Muscle Weakness </td>
                        <td className='w-187'> <input type="checkbox" name="cbBrainDisorders_3" id="cbBrainDisorders_3" className='add-only' value="3" /> Tics </td>
                        <td className='w-187'> <input type="checkbox" name="cbBrainDisorders_4" id="cbBrainDisorders_4" className='add-only' value="4" /> Headaches </td>
                    </tr>
                    <tr>
                        <td className='w-187'> <input type="checkbox" name="cbBrainDisorders_5" id="cbBrainDisorders_5" className='add-only' value="5" /> Head Injuries </td>
                        <td className='w-187'> <input type="checkbox" name="cbBrainDisorders_6" id="cbBrainDisorders_6" className='add-only' value="6" /> Seizures </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" name="cbBrainDisorders_7" id="cbBrainDisorders_7" className='add-only' value="7" /> Other: &nbsp;
                            <input type="text" name="txtSexualProblems_6Other" id="txtSexualProblems_6Other" className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Hormone Problems:</span>  </td>
                    </tr>
                    <tr>
                        <td className='w-187'> <input type="checkbox" name="cbHormoneProblems_1" id="cbHormoneProblems_1" className='add-only' value="1" /> Obesity </td>
                        <td className='w-187'> <input type="checkbox" name="cbHormoneProblems_2" id="cbHormoneProblems_2" className='add-only' value="2" /> Thyroid </td>
                        <td className='w-187'> <input type="checkbox" name="cbHormoneProblems_3" id="cbHormoneProblems_3" className='add-only' value="3" /> Early Puberty  </td>
                        <td className='w-187'> <input type="checkbox" name="cbHormoneProblems_4" id="cbHormoneProblems_4" className='add-only' value="4" /> Late Puberty  </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Sensory:</span>  </td>
                    </tr>
                    <tr>
                        <td className='w-187'> <input type="checkbox" name="cbSensory_1" id="cbSensory_1" className='add-only' value="1" /> Hearing </td>
                        <td className='w-187'> <input type="checkbox" name="cbSensory_2" id="cbSensory_2" className='add-only' value="2" /> Tactile </td>
                        <td className='w-187'> <input type="checkbox" name="cbSensory_3" id="cbSensory_3" className='add-only' value="3" /> Vision </td>
                        <td className='w-187'> <input type="checkbox" name="cbSensory_4" id="cbSensory_4" className='add-only' value="4" /> Speech </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Sexual Problems::</span>  </td>
                    </tr>
                    <tr>
                        <td className='w-187'> <input type="checkbox" name="cbSexualProblems_1" id="cbSexualProblems_1" className='add-only' value="1" /> Birth Control </td>
                        <td className='w-187'> <input type="checkbox" name="cbSexualProblems_2" id="cbSexualProblems_2" className='add-only' value="2" /> Masturbation </td>
                        <td className='w-187'> <input type="checkbox" name="cbSexualProblems_3" id="cbSexualProblems_3" className='add-only' value="3" /> Promiscuity </td>
                        <td className='w-187'> <input type="checkbox" name="cbSexualProblems_4" id="cbSexualProblems_4" className='add-only' value="4" /> Sexual Touching </td>
                    </tr>
                    <tr>
                        <td className='w-187'> <input type="checkbox" name="cbSexualProblems_5" id="cbSexualProblems_5" className='add-only' value="5" /> Sexual Offending </td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" name="cbSexualProblems_6" id="cbSexualProblems_6" className='add-only' value="6" /> Other: &nbsp;
                            <input type="text" name="txtSexualProblems_6Other" id="txtSexualProblems_6Other" className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Skin Disorders:</span>  </td>
                    </tr>
                    <tr>
                        <td className='w-187'> <input type="checkbox" name="cbSkinDisorders_1" id="cbSkinDisorders_1" className='add-only' value="1" /> Acne </td>
                        <td className='w-187'> <input type="checkbox" name="cbSkinDisorders_2" id="cbSkinDisorders_2" className='add-only' value="2" /> Birth Marks </td>
                        <td className='w-187'> <input type="checkbox" name="cbSkinDisorders_3" id="cbSkinDisorders_3" className='add-only' value="3" /> Eczema </td>
                        <td className='w-187'> <input type="checkbox" name="cbSkinDisorders_4" id="cbSkinDisorders_4" className='add-only' value="4" /> Hair Loss </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" name="cbSkinDisorders_5" id="cbSkinDisorders_5" className='add-only' value="5" /> Other: &nbsp;
                            <input type="text" name="txtSkinDisorders_5Other" id="txtSkinDisorders_5Other" className='add-only w-250 custom-add-only' />

                        </td>
                    </tr>


                </table>
                <p>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id="txtHomeSensory34" name="txtHomeSensory34" className='add-only'></textarea>
                </p>
                <h3>History of Emotional/Behavioral Problems & Treatment History:
                </h3>
                <h4>Behavior/Symptom Checklist
                </h4>
                <p>
                    <span className='eleHeader'>A. Psychosocial Stressors/Events</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPsychosocial" id="chkPsychosocial" className='add-only' value="Recent Death" /> Recent Death
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPsychosocial1" id="chkPsychosocial1" className='add-only' value="Legal Issues" /> Legal Issues
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPsychosocial2" id="chkPsychosocial2" className='add-only' value="Work School Problems" /> Work/School Problems
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPsychosocial3" id="chkPsychosocial3" className='add-only' value="Physical Sexual Abuse" /> Physical/Sexual Abuse
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPsychosocial4" id="chkPsychosocial4" className='add-only' value="Financial Difficulties" /> Financial Difficulties
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPsychosocial5" id="chkPsychosocial5" className='add-only' value="Separation Divorce" /> Separation/Divorce
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPsychosocial6" id="chkPsychosocial6" className='add-only' value="Homelessness" /> Homelessness
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPsychosocial7" id="chkPsychosocial7" className='add-only' value="Recent Hospitalization" /> Recent Hospitalization
                        </td>
                        <td className='w-250'>&nbsp; </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Behavioral evidence for all items at two or higher</span> <span className='small'>(include description of ideations, intentions, and /or plan, previous attempts/gestures, access to lethality of intended mea ns, ability to contract for safety, and other social supports such as family)</span>.
                    <textarea id="txtPreviousBehavioral" name="txtPreviousBehavioral" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>B. Current Symptoms/ Behaviors</span>
                </p>
                <table>
                    <tr>
                        <td className='w-200'>&nbsp;
                        </td>
                        <td className='w-200'>&nbsp;
                        </td>
                        <td className='w-70'>
                            <strong>None (1) </strong>
                        </td>
                        <td className='w-70'>
                            <strong>History Now Stable (2)</strong>
                        </td>
                        <td className='w-70'>
                            <strong>Mild / Infrequ-ent (3)</strong>
                        </td>
                        <td className='w-70'>
                            <strong>Moderate / Frequent (4)</strong>
                        </td>
                        <td className='w-70'>
                            <strong>Severe / Acute Crisis (5)</strong>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <strong>Danger to Self/Others</strong>
                        </td>
                        <td className='w-200'>
                            <strong>a. Suicidal Thought/Behavior</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbDanger_1" name="rbDanger" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbDanger_2" name="rbDanger" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbDanger_3" name="rbDanger" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbDanger_4" name="rbDanger" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbDanger_5" name="rbDanger" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>b. Homicidal Thought/Behavior</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbHomicidal_1" name="rbHomicidal" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbHomicidal_2" name="rbHomicidal" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbHomicidal_3" name="rbHomicidal" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbHomicidal_4" name="rbHomicidal" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbHomicidal_5" name="rbHomicidal" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>c. Aggressiveness</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbAggress_1" name="rbAggress" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbAggress_2" name="rbAggress" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbAggress_3" name="rbAggress" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbAggress_4" name="rbAggress" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbAggress_5" name="rbAggress" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>d. Self-Injurious Behavior</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbInjurious_1" name="rbInjurious" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbInjurious_2" name="rbInjurious" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbInjurious_3" name="rbInjurious" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbInjurious_4" name="rbInjurious" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbInjurious_5" name="rbInjurious" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>e. Sexual Trauma Perpetrator</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbTrauma_1" name="rbTrauma" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbTrauma_2" name="rbTrauma" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbTrauma_3" name="rbTrauma" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbTrauma_4" name="rbTrauma" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbTrauma_5" name="rbTrauma" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'><strong>Psychosis</strong></td>
                        <td className='w-200'>
                            <strong>a. Hallucinations</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbPsychosis_1" name="rbPsychosis" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbPsychosis_2" name="rbPsychosis" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbPsychosis_3" name="rbPsychosis" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbPsychosis_4" name="rbPsychosis" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbPsychosis_5" name="rbPsychosis" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>b. Delusions</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbDelusions_1" name="rbDelusions" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbDelusions_2" name="rbDelusions" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbDelusions_3" name="rbDelusions" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbDelusions_4" name="rbDelusions" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbDelusions_5" name="rbDelusions" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>c. Paranoia</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbParanoia_1" name="rbParanoia" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbParanoia_2" name="rbParanoia" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbParanoia_3" name="rbParanoia" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbParanoia_4" name="rbParanoia" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbParanoia_5" name="rbParanoia" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'><strong>Mood</strong></td>
                        <td className='w-200'>
                            <strong>a. Depressed Mood</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbDepressed_1" name="rbDepressed" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbDepressed_2" name="rbDepressed" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbDepressed_3" name="rbDepressed" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbDepressed_4" name="rbDepressed" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbDepressed_5" name="rbDepressed" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>b. Crying Spells</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbCrying_1" name="rbCrying" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbCrying_2" name="rbCrying" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbCrying_3" name="rbCrying" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbCrying_4" name="rbCrying" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbCrying_5" name="rbCrying" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>c. Increased Irritation/Agitation</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbAgitation_1" name="rbAgitation" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbAgitation_2" name="rbAgitation" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbAgitation_3" name="rbAgitation" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbAgitation_4" name="rbAgitation" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbAgitation_5" name="rbAgitation" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>d. Feelings of Worthlessness</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbWorthle_1" name="rbWorthle" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbWorthle_2" name="rbWorthle" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbWorthle_3" name="rbWorthle" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbWorthle_4" name="rbWorthle" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbWorthle_5" name="rbWorthle" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>e. Manic Thought/Behavior</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbManic_1" name="rbManic" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbManic_2" name="rbManic" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbManic_3" name="rbManic" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbManic_4" name="rbManic" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbManic_5" name="rbManic" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'><strong>Anxiety</strong></td>
                        <td className='w-200'>
                            <strong>a. Anxiety/Panic Attacks</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbAnxiety_1" name="rbAnxiety" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbAnxiety_2" name="rbAnxiety" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbAnxiety_3" name="rbAnxiety" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbAnxiety_4" name="rbAnxiety" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbAnxiety_5" name="rbAnxiety" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>b. Phobias</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbPhobias_1" name="rbPhobias" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbPhobias_2" name="rbPhobias" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbPhobias_3" name="rbPhobias" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbPhobias_4" name="rbPhobias" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbPhobias_5" name="rbPhobias" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>c. Biting Nails/Picking Skin</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbNails_1" name="rbNails" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbNails_2" name="rbNails" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbNails_3" name="rbNails" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbNails_4" name="rbNails" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbNails_5" name="rbNails" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>d. Obsessions/Compulsions</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbCompulsions_1" name="rbCompulsions" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbCompulsions_2" name="rbCompulsions" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbCompulsions_3" name="rbCompulsions" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbCompulsions_4" name="rbCompulsions" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbCompulsions_5" name="rbCompulsions" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'><strong>Addiction</strong></td>
                        <td className='w-200'>
                            <strong>a. Withdrawal</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbWithd_1" name="rbWithd" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbWithd_2" name="rbWithd" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbWithd_3" name="rbWithd" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbWithd_4" name="rbWithd" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbWithd_5" name="rbWithd" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>b. Alcohol Use/Abuse</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbUse_1" name="rbUse" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbUse_2" name="rbUse" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbUse_3" name="rbUse" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbUse_4" name="rbUse" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbUse_5" name="rbUse" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>c. Drug Use/Abuse</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbDrug_1" name="rbDrug" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbDrug_2" name="rbDrug" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbDrug_3" name="rbDrug" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbDrug_4" name="rbDrug" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbDrug_5" name="rbDrug" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>d. Uncontrolled Gambling</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbGambling_1" name="rbGambling" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbGambling_2" name="rbGambling" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbGambling_3" name="rbGambling" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbGambling_4" name="rbGambling" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbGambling_5" name="rbGambling" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'><strong>Behavior</strong></td>
                        <td className='w-200'>
                            <strong>a. Social Withdrawal</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbSocial_1" name="rbSocial" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbSocial_2" name="rbSocial" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbSocial_3" name="rbSocial" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbSocial_4" name="rbSocial" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbSocial_5" name="rbSocial" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>b. Difficulty making friends</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbDifficulty_1" name="rbDifficulty" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbDifficulty_2" name="rbDifficulty" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbDifficulty_3" name="rbDifficulty" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbDifficulty_4" name="rbDifficulty" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbDifficulty_5" name="rbDifficulty" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>c. Binges/Purging</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbBinges_1" name="rbBinges" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbBinges_2" name="rbBinges" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbBinges_3" name="rbBinges" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbBinges_4" name="rbBinges" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbBinges_5" name="rbBinges" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>d. Sexual Acting Out</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbOut_1" name="rbOut" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbOut_2" name="rbOut" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbOut_3" name="rbOut" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbOut_4" name="rbOut" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbOut_5" name="rbOut" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>e. Sexual Promiscuity</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbPromiscuity_1" name="rbPromiscuity" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbPromiscuity_2" name="rbPromiscuity" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbPromiscuity_3" name="rbPromiscuity" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbPromiscuity_4" name="rbPromiscuity" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbPromiscuity_5" name="rbPromiscuity" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>f. Distractibility/Impulsivity</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbImpulsivity_1" name="rbImpulsivity" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbImpulsivity_2" name="rbImpulsivity" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbImpulsivity_3" name="rbImpulsivity" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbImpulsivity_4" name="rbImpulsivity" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbImpulsivity_5" name="rbImpulsivity" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>g. Hyperactivity</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbHyper_1" name="rbHyper" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbHyper_2" name="rbHyper" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbHyper_3" name="rbHyper" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbHyper_4" name="rbHyper" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbHyper_5" name="rbHyper" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>h. Lying/Manipulative</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbLying_1" name="rbLying" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbLying_2" name="rbLying" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbLying_3" name="rbLying" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbLying_4" name="rbLying" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbLying_5" name="rbLying" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>i. Oppositional Behavior</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbOpposit_1" name="rbOpposit" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbOpposit_2" name="rbOpposit" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbOpposit_3" name="rbOpposit" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbOpposit_4" name="rbOpposit" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbOpposit_5" name="rbOpposit" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>j. Running Away</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbAway_1" name="rbAway" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbAway_2" name="rbAway" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbAway_3" name="rbAway" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbAway_4" name="rbAway" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbAway_5" name="rbAway" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>k. Truancy/Absenteeism</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbTruancy_1" name="rbTruancy" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbTruancy_2" name="rbTruancy" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbTruancy_3" name="rbTruancy" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbTruancy_4" name="rbTruancy" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbTruancy_5" name="rbTruancy" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>l. Property Destruction</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbProperty_1" name="rbProperty" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbProperty_2" name="rbProperty" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbProperty_3" name="rbProperty" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbProperty_4" name="rbProperty" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbProperty_5" name="rbProperty" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>m. Fire Setting</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbFire_1" name="rbFire" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbFire_2" name="rbFire" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbFire_3" name="rbFire" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbFire_4" name="rbFire" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbFire_5" name="rbFire" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>n. Cruelty to Animals</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbCruelty_1" name="rbCruelty" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbCruelty_2" name="rbCruelty" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbCruelty_3" name="rbCruelty" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbCruelty_4" name="rbCruelty" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbCruelty_5" name="rbCruelty" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>o. Stealing</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbStealing_1" name="rbStealing" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbStealing_2" name="rbStealing" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbStealing_3" name="rbStealing" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbStealing_4" name="rbStealing" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbStealing_5" name="rbStealing" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>p. Other Legal Issues</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbLegal_1" name="rbLegal" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbLegal_2" name="rbLegal" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbLegal_3" name="rbLegal" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbLegal_4" name="rbLegal" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbLegal_5" name="rbLegal" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'><strong>Physical / Cognitive</strong></td>
                        <td className='w-200'>
                            <strong>a. Change in Appetite</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbChange_1" name="rbChange" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbChange_2" name="rbChange" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbChange_3" name="rbChange" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbChange_4" name="rbChange" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbChange_5" name="rbChange" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>b. Weight Changes</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbWeight_1" name="rbWeight" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbWeight_2" name="rbWeight" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbWeight_3" name="rbWeight" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbWeight_4" name="rbWeight" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbWeight_5" name="rbWeight" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>c. Change in Energy Level</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbEnergy_1" name="rbEnergy" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbEnergy_2" name="rbEnergy" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbEnergy_3" name="rbEnergy" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbEnergy_4" name="rbEnergy" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbEnergy_5" name="rbEnergy" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>d. Sleep Disturbance</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbSleep_1" name="rbSleep" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbSleep_2" name="rbSleep" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbSleep_3" name="rbSleep" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbSleep_4" name="rbSleep" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbSleep_5" name="rbSleep" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>e. Decreased Concentration</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbConcen_1" name="rbConcen" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbConcen_2" name="rbConcen" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbConcen_3" name="rbConcen" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbConcen_4" name="rbConcen" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbConcen_5" name="rbConcen" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>f. Disorganized</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbDisorg_1" name="rbDisorg" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbDisorg_2" name="rbDisorg" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbDisorg_3" name="rbDisorg" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbDisorg_4" name="rbDisorg" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbDisorg_5" name="rbDisorg" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>g. Disoriented</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbDisor_1" name="rbDisor" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbDisor_2" name="rbDisor" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbDisor_3" name="rbDisor" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbDisor_4" name="rbDisor" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbDisor_5" name="rbDisor" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>h. Learning Problems</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbLearning_1" name="rbLearning" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbLearning_2" name="rbLearning" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbLearning_3" name="rbLearning" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbLearning_4" name="rbLearning" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbLearning_5" name="rbLearning" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>i. Behavior problems in school</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbBehav_1" name="rbBehav" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbBehav_2" name="rbBehav" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbBehav_3" name="rbBehav" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbBehav_4" name="rbBehav" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbBehav_5" name="rbBehav" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>j. Grades dropping/failing</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbGrades_1" name="rbGrades" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbGrades_2" name="rbGrades" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbGrades_3" name="rbGrades" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbGrades_4" name="rbGrades" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbGrades_5" name="rbGrades" className='add-only' value="5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>
                            <strong>k. Medical Complications/ Pain</strong>
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbMedical_1" name="rbMedical" className='add-only' value="1" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbMedical_2" name="rbMedical" className='add-only' value="2" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbMedical_3" name="rbMedical" className='add-only' value="3" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbMedical_4" name="rbMedical" className='add-only' value="4" />
                        </td>
                        <td className='w-70'>
                            <input type="radio" id="rbMedical_5" name="rbMedical" className='add-only' value="5" />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Behavioral Evidence for all items two or higher –</span>
                    <textarea id="txtBehavioralEvidence" name="txtBehavioralEvidence" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Consumer's Behaviors/Functioning 1 Year Ago:</span>
                    <textarea id="txtFunctioning" name="txtFunctioning" className='add-only'></textarea>
                </p>
                <h3>Substance Abuse/Addiction Assessment
                </h3>






                <p>
                    <span className='eleHeader'>Consumer Denies Substance Abuse History</span>
                    <input type="checkbox" name="chkConsumerDenies" id="chkConsumerDenies" className='add-only' value="None reported" /> None reported
                </p>
                <table> 
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Drugs:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Aged First Used:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Age of Heaviest Use:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><b>Alcohol</b>
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtAgedFirst" name="txtAgedFirst" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtHeaviest" name="txtHeaviest" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Recent Pattern of Use
                                (Frequency & Amount, etc.)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>Daily</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Weekly</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Occasionally</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>How Much? (Ex: # of blunts, etc.)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtDaily" name="txtDaily" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtWeekly" name="txtWeekly" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtOccasionally" name="txtOccasionally" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtBlunts" name="txtBlunts" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Date Last Used:</span>
                        </td>
                        <td className='w-500'>
                            <span className='eleHeader'>Specify Drug of Choice:
                                (Rate Primary, Secondary, Tertiary)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="date" id="txtBlunts34" name="txtBlunts34" className='add-only' />
                        </td>
                        <td className='w-500'>
                            <input type="text" id="txtSecondary" name="txtSecondary" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table> 
                    <tr>
                        <td className='w-750'><hr></hr></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Drugs:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Aged First Used:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Age of Heaviest Use:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><b>Cannabis</b>
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtAgedFirst1" name="txtAgedFirst1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtHeaviest1" name="txtHeaviest1" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Recent Pattern of Use
                                (Frequency & Amount, etc.)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>Daily</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Weekly</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Occasionally</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>How Much? (Ex: # of blunts, etc.)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtDaily1" name="txtDaily1" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtWeekly1" name="txtWeekly1" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtOccasionally1" name="txtOccasionally1" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtBlunts1" name="txtBlunts1" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Date Last Used:</span>
                        </td>
                        <td className='w-500'>
                            <span className='eleHeader'>Specify Drug of Choice:
                                (Rate Primary, Secondary, Tertiary)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="date" id="txtBlunts161" name="txtBlunts161" className='add-only'  />
                        </td>
                        <td className='w-500'>
                            <input type="text" id="txtSecondary1" name="txtSecondary1" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><hr></hr></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Drugs:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Aged First Used:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Age of Heaviest Use:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><b>Cocaine</b>
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtAgedFirst2" name="txtAgedFirst2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtHeaviest2" name="txtHeaviest2" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Recent Pattern of Use
                                (Frequency & Amount, etc.)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>Daily</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Weekly</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Occasionally</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>How Much? (Ex: # of blunts, etc.)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtDaily2" name="txtDaily2" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtWeekly2" name="txtWeekly2" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtOccasionally2" name="txtOccasionally2" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtBlunts2" name="txtBlunts2" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Date Last Used:</span>
                        </td>
                        <td className='w-500'>
                            <span className='eleHeader'>Specify Drug of Choice:
                                (Rate Primary, Secondary, Tertiary)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="date" id="txtBlunts256" name="txtBlunts256" className='add-only'  />
                        </td>
                        <td className='w-500'>
                            <input type="text" id="txtSecondary2" name="txtSecondary2" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><hr></hr></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Drugs:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Aged First Used:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Age of Heaviest Use:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><b>Stimulants (crystal, speed, amphetamines, etc)</b>
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtAgedFirst3" name="txtAgedFirst3" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtHeaviest3" name="txtHeaviest3" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Recent Pattern of Use
                                (Frequency & Amount, etc.)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>Daily</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Weekly</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Occasionally</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>How Much? (Ex: # of blunts, etc.)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtDaily3" name="txtDaily3" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtWeekly3" name="txtWeekly3" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtOccasionally3" name="txtOccasionally3" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtBlunts3" name="txtBlunts3" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Date Last Used:</span>
                        </td>
                        <td className='w-500'>
                            <span className='eleHeader'>Specify Drug of Choice:
                                (Rate Primary, Secondary, Tertiary)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="date" id="txtBlunts312" name="txtBlunts312" className='add-only'  />
                        </td>
                        <td className='w-500'>
                            <input type="text" id="txtSecondary3" name="txtSecondary3" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><hr></hr></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Drugs:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Aged First Used:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Age of Heaviest Use:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><b>Methamphetamine</b>
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtAgedFirst4" name="txtAgedFirst4" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtHeaviest4" name="txtHeaviest4" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Recent Pattern of Use
                                (Frequency & Amount, etc.)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>Daily</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Weekly</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Occasionally</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>How Much? (Ex: # of blunts, etc.)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtDaily4" name="txtDaily4" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtWeekly4" name="txtWeekly4" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtOccasionally4" name="txtOccasionally4" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtBlunts4" name="txtBlunts4" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Date Last Used:</span>
                        </td>
                        <td className='w-500'>
                            <span className='eleHeader'>Specify Drug of Choice:
                                (Rate Primary, Secondary, Tertiary)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="date" id="txtBlunts423" name="txtBlunts423" className='add-only'  />
                        </td>
                        <td className='w-500'>
                            <input type="text" id="txtSecondary4" name="txtSecondary4" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><hr></hr></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Drugs:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Aged First Used:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Age of Heaviest Use:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><b>Inhalants (gas, paint, glue, etc)</b>
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtAgedFirst5" name="txtAgedFirst5" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtHeaviest5" name="txtHeaviest5" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Recent Pattern of Use
                                (Frequency & Amount, etc.)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>Daily</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Weekly</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Occasionally</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>How Much? (Ex: # of blunts, etc.)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtDaily5" name="txtDaily5" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtWeekly5" name="txtWeekly5" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtOccasionally5" name="txtOccasionally5" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtBlunts5" name="txtBlunts5" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Date Last Used:</span>
                        </td>
                        <td className='w-500'>
                            <span className='eleHeader'>Specify Drug of Choice:
                                (Rate Primary, Secondary, Tertiary)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="date" id="txtBlunts521" name="txtBlunts521" className='add-only'  />
                        </td>
                        <td className='w-500'>
                            <input type="text" id="txtSecondary5" name="txtSecondary5" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><hr></hr></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Drugs:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Aged First Used:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Age of Heaviest Use:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><b>Hallucinogens (LSD, PCP, mushrooms, etc)</b>
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtAgedFirst6" name="txtAgedFirst6" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtHeaviest6" name="txtHeaviest6" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Recent Pattern of Use
                                (Frequency & Amount, etc.)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>Daily</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Weekly</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Occasionally</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>How Much? (Ex: # of blunts, etc.)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtDaily6" name="txtDaily6" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtWeekly6" name="txtWeekly6" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtOccasionally6" name="txtOccasionally6" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtBlunts6" name="txtBlunts6" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Date Last Used:</span>
                        </td>
                        <td className='w-500'>
                            <span className='eleHeader'>Specify Drug of Choice:
                                (Rate Primary, Secondary, Tertiary)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="date" id="txtBlunts611" name="txtBlunts611" className='add-only'  />
                        </td>
                        <td className='w-500'>
                            <input type="text" id="txtSecondary6" name="txtSecondary6" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><hr></hr></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Drugs:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Aged First Used:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Age of Heaviest Use:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><b>Opioids (heroin, narcotics, methadone, etc)</b>
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtAgedFirst7" name="txtAgedFirst7" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtHeaviest7" name="txtHeaviest7" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Recent Pattern of Use
                                (Frequency & Amount, etc.)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>Daily</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Weekly</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Occasionally</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>How Much? (Ex: # of blunts, etc.)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtDaily7" name="txtDaily7" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtWeekly7" name="txtWeekly7" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtOccasionally7" name="txtOccasionally7" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtBlunts7" name="txtBlunts7" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Date Last Used:</span>
                        </td>
                        <td className='w-500'>
                            <span className='eleHeader'>Specify Drug of Choice:
                                (Rate Primary, Secondary, Tertiary)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="date" id="txtBlunts711" name="txtBlunts711" className='add-only'   />
                        </td>
                        <td className='w-500'>
                            <input type="text" id="txtSecondary7" name="txtSecondary7" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><hr></hr></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Drugs:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Aged First Used:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Age of Heaviest Use:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><b>Sedative/Hypnotics (Valium, Phenobarb, etc)</b>
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtAgedFirst8" name="txtAgedFirst8" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtHeaviest8" name="txtHeaviest8" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Recent Pattern of Use
                                (Frequency & Amount, etc.)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>Daily</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Weekly</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Occasionally</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>How Much? (Ex: # of blunts, etc.)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtDaily8" name="txtDaily8" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtWeekly8" name="txtWeekly8" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtOccasionally8" name="txtOccasionally8" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtBlunts8" name="txtBlunts8" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Date Last Used:</span>
                        </td>
                        <td className='w-500'>
                            <span className='eleHeader'>Specify Drug of Choice:
                                (Rate Primary, Secondary, Tertiary)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="date" id="txtBlunts844" name="txtBlunts844" className='add-only'   />
                        </td>
                        <td className='w-500'>
                            <input type="text" id="txtSecondary8" name="txtSecondary8" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><hr></hr></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Drugs:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Aged First Used:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Age of Heaviest Use:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><b>Designer Drugs/Other (herbal, Steroids, cough syrup, etc)</b>
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtAgedFirst9" name="txtAgedFirst9" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtHeaviest9" name="txtHeaviest9" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Recent Pattern of Use
                                (Frequency & Amount, etc.)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>Daily</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Weekly</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Occasionally</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>How Much? (Ex: # of blunts, etc.)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtDaily9" name="txtDaily9" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtWeekly9" name="txtWeekly9" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtOccasionally9" name="txtOccasionally9" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtBlunts9" name="txtBlunts9" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Date Last Used:</span>
                        </td>
                        <td className='w-500'>
                            <span className='eleHeader'>Specify Drug of Choice:
                                (Rate Primary, Secondary, Tertiary)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="date" id="txtBlunts91" name="txtBlunts91" className='add-only'  />
                        </td>
                        <td className='w-500'>
                            <input type="text" id="txtSecondary9" name="txtSecondary9" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><hr></hr></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Drugs:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Aged First Used:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Age of Heaviest Use:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><b>Tobacco (smoke, chew)</b>
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtAgedFirst11" name="txtAgedFirst11" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtHeaviest11" name="txtHeaviest11" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Recent Pattern of Use
                                (Frequency & Amount, etc.)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>Daily</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Weekly</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Occasionally</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>How Much? (Ex: # of blunts, etc.)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtDaily11" name="txtDaily11" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtWeekly11" name="txtWeekly11" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtOccasionally11" name="txtOccasionally11" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtBlunts11" name="txtBlunts11" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Date Last Used:</span>
                        </td>
                        <td className='w-500'>
                            <span className='eleHeader'>Specify Drug of Choice:
                                (Rate Primary, Secondary, Tertiary)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="date" id="txtBlunts114" name="txtBlunts114" className='add-only'  />
                        </td>
                        <td className='w-500'>
                            <input type="text" id="txtSecondary11" name="txtSecondary11" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><hr></hr></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Drugs:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Aged First Used:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Age of Heaviest Use:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><b>Caffeine</b>
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtAgedFirst12" name="txtAgedFirst12" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtHeaviest12" name="txtHeaviest12" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Recent Pattern of Use
                                (Frequency & Amount, etc.)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>Daily</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Weekly</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Occasionally</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>How Much? (Ex: # of blunts, etc.)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtDaily12" name="txtDaily12" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtWeekly12" name="txtWeekly12" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtOccasionally12" name="txtOccasionally12" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtBlunts12" name="txtBlunts12" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Date Last Used:</span>
                        </td>
                        <td className='w-500'>
                            <span className='eleHeader'>Specify Drug of Choice:
                                (Rate Primary, Secondary, Tertiary)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="date" id="txtBlunts126" name="txtBlunts126" className='add-only' />
                        </td>
                        <td className='w-500'>
                            <input type="text" id="txtSecondary12" name="txtSecondary12" className='add-only' />
                        </td>
                    </tr>
                </table>


                
                <p>
                    <span className='eleHeader'>Ever injected Drugs?</span>
                    <input type="radio" id="rbEver_Yes" name="rbEver" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbEver_No" name="rbEver" className='add-only' value="0" /> No
                </p>
                <p>
                    If yes, which ones?<input type="text" id="txtEver" name="txtEver" className='add-only' /><br />
                    <input type="checkbox" name="chkEver" id="chkEver" className='add-only' value="None reported" /> None reported
                </p>
                <h3>Treatment History:
                </h3>
                <table>
                    <tr>
                        <td className='w-780'>
                            <strong>Treatment</strong>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <strong># Inpatient Hospitalizations</strong>
                        </td>
                        <td className='w-125'>
                            <strong># CSP Admissions/ Crisis Group Home:</strong>
                        </td>
                        <td className='w-125'>
                            <strong># ER/Crisis Team Involvements</strong>
                        </td>
                        <td className='w-125'>
                            <strong># Substance Abuse Detoxification Attempts:</strong>
                        </td>
                        <td className='w-125'>
                            <strong># Group Home Placements</strong>
                        </td>
                        <td className='w-125'>
                            <strong># PRTF Placements</strong>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type="text" id="txtInpatient" name="txtInpatient" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtAdmissions" name="txtAdmissions" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtCrisis" name="txtCrisis" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtSubstance" name="txtSubstance" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtGroup" name="txtGroup" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtPlacements" name="txtPlacements" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type="text" id="txtInpatient1" name="txtInpatient1" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtAdmissions1" name="txtAdmissions1" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtCrisis1" name="txtCrisis1" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtSubstance1" name="txtSubstance1" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtGroup1" name="txtGroup1" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtPlacements1" name="txtPlacements1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type="text" id="txtInpatient2" name="txtInpatient2" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtAdmissions2" name="txtAdmissions2" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtCrisis2" name="txtCrisis2" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtSubstance2" name="txtSubstance2" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtGroup2" name="txtGroup2" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtPlacements2" name="txtPlacements2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type="text" id="txtInpatient3" name="txtInpatient3" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtAdmissions3" name="txtAdmissions3" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtCrisis3" name="txtCrisis3" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtSubstance3" name="txtSubstance3" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtGroup3" name="txtGroup3" className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type="text" id="txtPlacements3" name="txtPlacements3" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <strong>Dates</strong>
                        </td>
                        <td className='w-500'>
                            <strong>Name of Location</strong>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="date" id="txtLocationDate" name="txtLocationDate" className='add-only'  />
                        </td>
                        <td className='w-500'>
                            <input type="text" id="txtLocation" name="txtLocation" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="date" id="txtLocationDate1" name="txtLocationDate1" className='add-only'  />
                        </td>
                        <td className='w-500'>
                            <input type="text" id="txtLocation1" name="txtLocation1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="date" id="txtLocationDate2" name="txtLocationDate2" className='add-only'   />
                        </td>
                        <td className='w-500'>
                            <input type="text" id="txtLocation2" name="txtLocation2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="date" id="txtLocationDate3" name="txtLocationDate3" className='add-only'   />
                        </td>
                        <td className='w-500'>
                            <input type="text" id="txtLocation3" name="txtLocation3" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Other Treatment History</span>
                    <textarea id="txtTreatmentHistory" name="txtTreatmentHistory" className='add-only'></textarea>
                </p>
                <h3>History of Significant Traumas:
                </h3>
                <table>
                    <tr>
                        <td className='w-300'>
                            <strong>Type of Trauma</strong>
                        </td>
                        <td className='w-50'>
                            <strong>Yes</strong>
                        </td>
                        <td className='w-50'>
                            <strong>No</strong>
                        </td>
                        <td className='w-350'>
                            <strong>If Yes, Explanation</strong>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Did you ever experience inappropriate touching of a sexual nature, or touching that made you feel uncomfortable?
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbTraumaR_Yes" name="rbTraumaR" className='add-only' value="1" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbTraumaR_No" name="rbTraumaR" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtExplanation" name="txtExplanation" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Were you ever punished by a parent/guardian with hitting that left bruises or bleeding?
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbTraumaR1_Yes" name="rbTraumaR1" className='add-only' value="1" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbTraumaR1_No" name="rbTraumaR1" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtExplanation1" name="txtExplanation1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Did you ever think you parents/guardians were abusive?
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbTraumaR2_Yes" name="rbTraumaR2" className='add-only' value="1" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbTraumaR2_No" name="rbTraumaR2" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtExplanation2" name="txtExplanation2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Did your parents/guardians ever call you insulting names like “stupid, brat, bitch” or any others you can recall?
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbTraumaR3_Yes" name="rbTraumaR3" className='add-only' value="1" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbTraumaR3_No" name="rbTraumaR3" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtExplanation3" name="txtExplanation3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Did anyone in your house get drunk? Use drugs? (including prescription drugs)
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbTraumaR4_Yes" name="rbTraumaR4" className='add-only' value="1" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbTraumaR4_No" name="rbTraumaR4" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtExplanation4" name="txtExplanation4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Did anyone in your house get violent, hitting things, throwing things, hitting people, breaking things, etc?
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbTraumaR5_Yes" name="rbTraumaR5" className='add-only' value="1" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbTraumaR5_No" name="rbTraumaR5" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtExplanation5" name="txtExplanation5" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Were you or anyone in your home involved in a serious accident?
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbTraumaR6_Yes" name="rbTraumaR6" className='add-only' value="1" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbTraumaR6_No" name="rbTraumaR6" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtExplanation6" name="txtExplanation6" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Was anyone in your home diagnosed with a mental illness?
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbTraumaR7_Yes" name="rbTraumaR7" className='add-only' value="1" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbTraumaR7_No" name="rbTraumaR7" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtExplanation7" name="txtExplanation7" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Was anyone in your home physically or sexually abused? Did you witness it?
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbTraumaR8_Yes" name="rbTraumaR8" className='add-only' value="1" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbTraumaR8_No" name="rbTraumaR8" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtExplanation8" name="txtExplanation8" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Were you threatened by or did you experience a natural catastrophe, such as major earthquakes, hurricanes, floods, typhoons, tornadoes, etc?
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbTraumaR9_Yes" name="rbTraumaR9" className='add-only' value="1" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbTraumaR9_No" name="rbTraumaR9" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtExplanation9" name="txtExplanation9" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Did either of parents/guardians serve in the military? Was he or she ever in battle? Was he or she diagnosed with PTSD or anything similar?
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbTraumaR11_Yes" name="rbTraumaR11" className='add-only' value="1" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbTraumaR11_No" name="rbTraumaR11" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtExplanation11" name="txtExplanation11" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Did you use drugs or alcohol?
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbTraumaR12_Yes" name="rbTraumaR12" className='add-only' value="1" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbTraumaR12_No" name="rbTraumaR12" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtExplanation12" name="txtExplanation12" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Did you or anyone in your family attempt suicide? Did anyone succeed? Did you witness it?
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbTraumaR13_Yes" name="rbTraumaR13" className='add-only' value="1" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbTraumaR13_No" name="rbTraumaR13" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtExplanation13" name="txtExplanation13" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>Spiritual/Cultural Awareness:
                </h3>
                <p>
                    <span className='eleHeader'>Knowledgeable about traditions, spirituality, or religion?</span>
                    <input type="radio" id="rbKnowledgeable_Yes" name="rbKnowledgeable" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbKnowledgeable_No" name="rbKnowledgeable" className='add-only' value="0" /> No
                </p>
                <p>
                    Comments:<textarea id="txtKnowledgeable" name="txtKnowledgeable" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Practices traditions, spirituality, or religion?</span>
                    <input type="radio" id="rbPractices_Yes" name="rbPractices" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbPractices_No" name="rbPractices" className='add-only' value="0" /> No
                </p>
                <p>
                    Comments:<textarea id="txtPractices" name="txtPractices" className='add-only'></textarea>
                </p>
                <p>
                    How does consumer describe his/her spirituality?<input type="text" id="txtAlternatePhoneNumberconsumer" name="txtAlternatePhoneNumberconsumer" className='add-only' />
                </p>
                <p>
                    <strong>Comments:</strong>
                </p>
                <p>
                    <span className='eleHeader'>Does the consumer see a traditional healer?</span>
                    <input type="radio" id="rbTraditional_Yes" name="rbTraditional" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbTraditional_No" name="rbTraditional" className='add-only' value="0" /> No
                </p>
                <p>
                    Comments:<textarea id="txtTraditional" name="txtTraditional" className='add-only'></textarea>
                </p>
                <h3>Legal involvement:
                </h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Past or current legal problems (select all that apply)?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPastLegal1" id="chkPastLegal1" className='add-only' value="None" /> None
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPastLegal2" id="chkPastLegal2" className='add-only' value="Gangs" /> Gangs
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPastLegal3" id="chkPastLegal3" className='add-only' value="DUI/DWI" /> DUI/DWI
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPastLegal4" id="chkPastLegal4" className='add-only' value="Arrests" /> Arrests
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPastLegal5" id="chkPastLegal5" className='add-only' value="Conviction" /> Conviction
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPastLegal6" id="chkPastLegal6" className='add-only' value="Detention" /> Detention
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPastLegal7" id="chkPastLegal7" className='add-only' value="Jail" /> Jail
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPastLegal74" id="chkPastLegal74" className='add-only' value="Probation" /> Probation
                        </td>
                        <td className='w-250'>&nbsp; </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Is Consumer Involved with the Department of Juvenile Justice?</span>
                    <input type="radio" id="rbActiveConsumer_Yes" name="rbActiveConsumer" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbActiveConsumer_No" name="rbActiveConsumer" className='add-only' value="0" /> No
                </p>
                <p>
                    Number of times consumer has been arrested in the last 30 days<input type="text" id="txtTimes" name="txtTimes" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>History of Juvenile Justice Involvement?</span>
                    <input type="radio" id="rbActiveConsumer1_Yes" name="rbActiveConsumer1" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbActiveConsumer1_No" name="rbActiveConsumer1" className='add-only' value="0" /> No
                </p>
                <p>
                    <span className='eleHeader'>If yes to any of the above, please explain:</span>
                    <textarea id="txtJuvenile" name="txtJuvenile" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Any court-ordered treatment?</span>
                    <input type="radio" id="rbActiveConsumer2_Yes" name="rbActiveConsumer2" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbActiveConsumer2_No" name="rbActiveConsumer2" className='add-only' value="0" /> No
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Ordered by:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Offense:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Length of Time:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtOrdered" name="txtOrdered" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtOffense" name="txtOffense" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtLengthTime" name="txtLengthTime" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>Interactions with Adults & Peers:
                </h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Client reports satisfaction with his/her family relationships</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-550'>Client reports satisfaction with his/her family relationships</td>
                        <td className='w-100'>
                            <input type="radio" id="rbPeers_Yes" name="rbPeers" className='add-only' value="1" /> Yes &nbsp;
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbPeers_No" name="rbPeers" className='add-only' value="0" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-550'>Client reports satisfaction with his/her social relationships and activities.</td>
                        <td className='w-100'>
                            <input type="radio" id="rbPeers1_Yes" name="rbPeers1" className='add-only' value="1" /> Yes &nbsp;
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbPeers1_No" name="rbPeers1" className='add-only' value="0" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-550'>Client reports satisfaction with the entertainment/recreational activities he/she selects.</td>
                        <td className='w-100'>
                            <input type="radio" id="rbPeers2_Yes" name="rbPeers2" className='add-only' value="1" /> Yes &nbsp;
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbPeers2_No" name="rbPeers2" className='add-only' value="0" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-550'>Client expresses an interest in his community and the world, in general.</td>
                        <td className='w-100'>
                            <input type="radio" id="rbPeers3_Yes" name="rbPeers3" className='add-only' value="1" /> Yes &nbsp;
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbPeers3_No" name="rbPeers3" className='add-only' value="0" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-550'>Client has a history of or current legal involvement.</td>
                        <td className='w-100'>
                            <input type="radio" id="rbPeers4_Yes" name="rbPeers4" className='add-only' value="1" /> Yes &nbsp;
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbPeers4_No" name="rbPeers4" className='add-only' value="0" /> No
                        </td>
                    </tr>
                </table>
                <p>
                    Comments:<textarea id="txtComments5" name="txtComments5" className='add-only'></textarea>
                </p>
                <h3>Educational Information :
                </h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Current Educational Setting:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkCurrentEducational" id="chkCurrentEducational" className='add-only' value="Public" /> Public
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkCurrentEducational1" id="chkCurrentEducational1" className='add-only' value="Private" /> Private
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkCurrentEducational2" id="chkCurrentEducational2" className='add-only' value="Boarding" /> Boarding
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkCurrentEducational3" id="chkCurrentEducational3" className='add-only' value="Charter" /> Charter
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkCurrentEducational4" id="chkCurrentEducational4" className='add-only' value="Home" /> Home
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkCurrentEducational5" id="chkCurrentEducational5" className='add-only' value="Private" /> Private
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkCurrentEducational6" id="chkCurrentEducational6" className='add-only' value="Technical" /> Technical
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkCurrentEducational7" id="chkCurrentEducational7" className='add-only' value="Alternative" /> Alternative
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkCurrentEducational8" id="chkCurrentEducational8" className='add-only' value="GED" /> GED
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkCurrentEducational81" id="chkCurrentEducational81" className='add-only' value="Dropped Out" /> Dropped Out
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type="checkbox" name="chkCurrentEducational9" id="chkCurrentEducational9" className='add-only' value="Not Enrolled" /> Not Enrolled:
                            <input type="text" id="txtCurrentEducational" name="txtCurrentEducational" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Current Grade Level</span>
                    <input type="text" id="txtCurrentGrade" name="txtCurrentGrade" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Skipped a grade?</span>
                    <input type="radio" id="rbSkipped_Yes" name="rbSkipped" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbSkipped_No" name="rbSkipped" className='add-only' value="0" /> No
                </p>
                <p>
                    <span className='eleHeader'>Held back?</span>
                    <input type="radio" id="rbHeld_Yes" name="rbHeld" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbHeld_No" name="rbHeld" className='add-only' value="0" /> No
                </p>
                <p>
                    <span className='eleHeader'>Any testing for an IEP</span><span className='small'> (Individualized Education Plan)?</span>
                    <input type="radio" id="rbHeldPlan_Yes" name="rbHeldPlan" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbHeldPlan_No" name="rbHeldPlan" className='add-only' value="0" /> No
                </p>
                <p>
                    <span className='eleHeader'>History of /or current placement in special education?</span>
                    <input type="radio" id="rbHeldPlanHistory_Yes" name="rbHeldPlanHistory" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbHeldPlanHistory_No" name="rbHeldPlanHistory" className='add-only' value="0" /> No
                </p>
                <p>
                    If yes, specify number of hours per day?<input type="text" id="txtHeldPlanHistory" name="txtHeldPlanHistory" className='add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-550'>
                            <strong>For learning problems?</strong>
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbLearning_Yes" name="rbLearning" className='add-only' value="1" /> Yes &nbsp;
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbLearning_No" name="rbLearning" className='add-only' value="0" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-550'>
                            <strong>History of hyperactivity at school?</strong>
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbLearning1_Yes" name="rbLearning1" className='add-only' value="1" /> Yes &nbsp;
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbLearning1_No" name="rbLearning1" className='add-only' value="0" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-550'>
                            <strong>History of behavior problems at school?</strong>
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbLearning2_Yes" name="rbLearning2" className='add-only' value="1" /> Yes &nbsp;
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbLearning2_No" name="rbLearning2" className='add-only' value="0" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-550'>
                            <strong>Ever been expelled or suspended?</strong>
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbLearning3_Yes" name="rbLearning3" className='add-only' value="1" /> Yes &nbsp;
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbLearning3_No" name="rbLearning3" className='add-only' value="0" /> No
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>School attendance problems:</span>
                    <input type="radio" id="rbAttendance_Yes" name="rbAttendance" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbAttendance_No" name="rbAttendance" className='add-only' value="0" /> No
                </p>
                <p>
                    If yes, how many days absent in the last 30 days?
                    <input type="text" id="txtHeldPlanHistoryA" name="txtHeldPlanHistoryA" className='add-only' />
                </p>
                <p>
                    Other education-related concerns:
                    <textarea id="txtOtherConcerns" name="txtOtherConcerns" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Psychological:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-550'> Client accepts responsibility for creating his/her own feelings.</td>
                        <td className='w-100'>
                            <input type="radio" id="rbAccepts_Yes" name="rbAccepts" className='add-only' value="1" /> Yes &nbsp;
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbAccepts_No" name="rbAccepts" className='add-only' value="0" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-550'>Client accepts responsibility for his/her own actions.</td>
                        <td className='w-100'>
                            <input type="radio" id="rbAccepts1_Yes" name="rbAccepts1" className='add-only' value="1" /> Yes &nbsp;
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbAccepts1_No" name="rbAccepts1" className='add-only' value="0" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-550'>Client makes decisions with a minimum of stress and worry.</td>
                        <td className='w-100'>
                            <input type="radio" id="rbAccepts2_Yes" name="rbAccepts2" className='add-only' value="1" /> Yes &nbsp;
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbAccepts2_No" name="rbAccepts2" className='add-only' value="0" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-550'>Client is able to express feelings of anger, disappointment, frustration, etc.</td>
                        <td className='w-100'>
                            <input type="radio" id="rbAccepts3_Yes" name="rbAccepts3" className='add-only' value="1" /> Yes &nbsp;
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbAccepts3_No" name="rbAccepts3" className='add-only' value="0" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-550'>Client reports a stable emotional life.</td>
                        <td className='w-100'>
                            <input type="radio" id="rbAccepts4_Yes" name="rbAccepts4" className='add-only' value="1" /> Yes &nbsp;
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbAccepts4_No" name="rbAccepts4" className='add-only' value="0" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-550'>Client feels enthusiastic about his/her life.</td>
                        <td className='w-100'>
                            <input type="radio" id="rbAccepts5_Yes" name="rbAccepts5" className='add-only' value="1" /> Yes &nbsp;
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbAccepts5_No" name="rbAccepts5" className='add-only' value="0" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-550'>Client reports adequate energy level.</td>
                        <td className='w-100'>
                            <input type="radio" id="rbAccepts6_Yes" name="rbAccepts6" className='add-only' value="1" /> Yes &nbsp;
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbAccepts6_No" name="rbAccepts6" className='add-only' value="0" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-550'>Client reports sleep is restful & adequate.</td>
                        <td className='w-100'>
                            <input type="radio" id="rbAccepts7_Yes" name="rbAccepts7" className='add-only' value="1" /> Yes &nbsp;
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbAccepts7_No" name="rbAccepts7" className='add-only' value="0" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-550'>Client reports he/she feels positive about self.</td>
                        <td className='w-100'>
                            <input type="radio" id="rbAccepts8_Yes" name="rbAccepts8" className='add-only' value="1" /> Yes &nbsp;
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbAccepts8_No" name="rbAccepts8" className='add-only' value="0" /> No
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Name of Primary Care Physician:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Address:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>CITY</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtPrimaryCare" name="txtPrimaryCare" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtPhoneNumberAddress" name="txtPhoneNumberAddress" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtAlternateCity" name="txtAlternateCity" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Office Phone:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Fax Number:</span>
                        </td>
                        <td className='w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtOfficePhone" name="txtOfficePhone" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtFaxNumber" name="txtFaxNumber" className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp; </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Overall Health:</span>
                    <textarea id="txtOverallHealth" name="txtOverallHealth" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Hospitalizations:</span>
                    <textarea id="txtOverallHealth1" name="txtOverallHealth1" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Major Illnesses:</span>
                    <textarea id="txtOverallHealth2" name="txtOverallHealth2" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Allergies: (Including medication and food)</span>
                    <textarea id="txtOverallHealth3" name="txtOverallHealth3" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Last Physical Exam:</span>
                    <textarea id="txtOttxtOverallHealthher4" name="txtOverallHealth4" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Last Dental Exam:</span>
                    <textarea id="txtOverallHealth5" name="txtOverallHealth5" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Medical Problems? If so, please describe:</span>

                    <textarea id="txtOverallHealth6" name="txtOverallHealth6" className='add-only'></textarea>
                </p>
                <h3>Psychiatric Medications:
                </h3>
                <table>
                    <tr>
                        <td className='w-100'>
                            <span className='eleHeader'>Medication</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>Amo-unt</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Time</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Purpose</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Start Date</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Discontinued Date</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type="text" id="txtMedication" name="txtMedication" className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type="text" id="txtAmount" name="txtAmount" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="time" id="txtTime" name="txtTime" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtPurpose" name="txtPurpose" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtStartDate" name="txtStartDate" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtDiscontinued" name="txtDiscontinued" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type="text" id="txtMedication1" name="txtMedication1" className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type="text" id="txtAmount1" name="txtAmount1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="time" id="txtTime1" name="txtTime1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtPurpose1" name="txtPurpose1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtStartDate1" name="txtStartDate1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtDiscontinued1" name="txtDiscontinued1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type="text" id="txtMedication2" name="txtMedication2" className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type="text" id="txtAmount2" name="txtAmount2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="time" id="txtTime2" name="txtTime2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtPurpose2" name="txtPurpose2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtStartDate2" name="txtStartDate2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtDiscontinued2" name="txtDiscontinued2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type="text" id="txtMedication3" name="txtMedication3" className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type="text" id="txtAmount3" name="txtAmount3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="time" id="txtTime3" name="txtTime3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtPurpose3" name="txtPurpose3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtStartDate3" name="txtStartDate3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtDiscontinued3" name="txtDiscontinued3" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>GENERAL OBSERVATIONS:
                </h3>
                <p>
                    <span className='eleHeader'>Appearance</span>
                    <input type="radio" id="rbAppearance_Yes" name="rbAppearance" className='add-only' value="1" /> Well groomed &nbsp;
                    <input type="radio" id="rbAppearance_No" name="rbAppearance" className='add-only' value="0" /> Unkept &nbsp;
                    <input type="radio" id="rbAppearance_Na" name="rbAppearance" className='add-only' value="2" /> Disheveled &nbsp;
                    <input type="radio" id="rbAppearance_Nc" name="rbAppearance" className='add-only' value="3" /> Malodorous
                </p>
                <p>
                    <span className='eleHeader'>Build</span>
                    <input type="radio" id="rbBuild_Yes" name="rbBuild" className='add-only' value="1" /> Average &nbsp;
                    <input type="radio" id="rbBuild_No" name="rbBuild" className='add-only' value="0" /> Thin &nbsp;
                    <input type="radio" id="rbBuild_Na" name="rbBuild" className='add-only' value="2" /> Overweight &nbsp;
                    <input type="radio" id="rbBuild_Nc" name="rbBuild" className='add-only' value="3" /> Severely Obese
                </p>
                <p>
                    <span className='eleHeader'>Demeanor</span>
                    <input type="radio" id="rbBuild1_Yes" name="rbBuild1" className='add-only' value="1" /> Cooperative &nbsp;
                    <input type="radio" id="rbBuild1_No" name="rbBuild1" className='add-only' value="0" /> Hostile &nbsp;
                    <input type="radio" id="rbBuild1_Na" name="rbBuild1" className='add-only' value="2" /> Guarded &nbsp;
                    <input type="radio" id="rbBuild1_Nc" name="rbBuild1" className='add-only' value="3" /> Withdrawn &nbsp;
                    <input type="radio" id="rbBuild1_Ye" name="rbBuild1" className='add-only' value="5" /> Preoccupied &nbsp;
                    <input type="radio" id="rbBuild1_N" name="rbBuild1" className='add-only' value="6" /> Demanding &nbsp;
                    <input type="radio" id="rbBuild1_NB" name="rbBuild1" className='add-only' value="7" /> Seductive
                </p>
                <p>
                    <span className='eleHeader'>Eye Contact</span>
                    <input type="radio" id="rbBuild2_Yes" name="rbBuild2" className='add-only' value="1" /> Average &nbsp;
                    <input type="radio" id="rbBuild2_No" name="rbBuild2" className='add-only' value="0" /> Decreased &nbsp;
                    <input type="radio" id="rbBuild2_Na" name="rbBuild2" className='add-only' value="2" /> Increased
                </p>
                <p>
                    <span className='eleHeader'>Activity</span>
                    <input type="radio" id="rbBuild3_Yes" name="rbBuild3" className='add-only' value="1" /> Average &nbsp;
                    <input type="radio" id="rbBuild3_No" name="rbBuild3" className='add-only' value="0" /> Decreased &nbsp;
                    <input type="radio" id="rbBuild3_Na" name="rbBuild3" className='add-only' value="2" /> Increased
                </p>
                <p>
                    <span className='eleHeader'>Speech</span>
                    <input type="radio" id="rbSpeech_1" name="rbSpeech" className='add-only' value="1" /> Average &nbsp;
                    <input type="radio" id="rbSpeech_0" name="rbSpeech" className='add-only' value="0" /> Decreased &nbsp;
                    <input type="radio" id="rbSpeech_2" name="rbSpeech" className='add-only' value="2" /> Increased &nbsp;
                    <input type="radio" id="rbSpeech_3" name="rbSpeech" className='add-only' value="3" /> Slow &nbsp;
                    <input type="radio" id="rbSpeech_5" name="rbSpeech" className='add-only' value="5" /> Pressured &nbsp;
                    <input type="radio" id="rbSpeech_6" name="rbSpeech" className='add-only' value="6" /> Soft &nbsp;
                    <input type="radio" id="rbSpeech_7" name="rbSpeech" className='add-only' value="7" /> Loud &nbsp;
                    <input type="radio" id="rbSpeech_8" name="rbSpeech" className='add-only' value="8" /> Monotone
                </p>
                <p>
                    Describe:<textarea id="txtOtherDescribe" name="txtOtherDescribe" className='add-only'></textarea>
                </p>
                <h3>THOUGHT CONTENT
                </h3>
                <p>
                    <span className='eleHeader'>Delusions</span>
                    <input type="radio" id="rbSpeech1_1" name="rbSpeech1" className='add-only' value="1" /> None Reported &nbsp;
                    <input type="radio" id="rbSpeech1_0" name="rbSpeech1" className='add-only' value="0" /> Grandiose &nbsp;
                    <input type="radio" id="rbSpeech1_2" name="rbSpeech1" className='add-only' value="2" /> Persecutory &nbsp;
                    <input type="radio" id="rbSpeech1_3" name="rbSpeech1" className='add-only' value="3" /> Somatic &nbsp;
                    <input type="radio" id="rbSpeech1_5" name="rbSpeech1" className='add-only' value="5" /> Bizarre &nbsp;
                    <input type="radio" id="rbSpeech1_6" name="rbSpeech1" className='add-only' value="6" /> Nihilist &nbsp;
                    <input type="radio" id="rbSpeech1_7" name="rbSpeech1" className='add-only' value="7" /> Religious
                </p>
                <p>
                    Describe:<textarea id="txtOtherDescribe1" name="txtOtherDescribe1" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Other</span>
                    <input type="radio" id="rbSpeech2_1" name="rbSpeech2" className='add-only' value="1" /> Average &nbsp;
                    <input type="radio" id="rbSpeech2_0" name="rbSpeech2" className='add-only' value="0" /> Poverty of Content &nbsp;
                    <input type="radio" id="rbSpeech2_2" name="rbSpeech2" className='add-only' value="2" /> Obsessions &nbsp;
                    <input type="radio" id="rbSpeech2_3" name="rbSpeech2" className='add-only' value="3" /> Compulsions &nbsp;
                    <input type="radio" id="rbSpeech2_5" name="rbSpeech2" className='add-only' value="5" /> Phobias &nbsp;
                    <input type="radio" id="rbSpeech2_6" name="rbSpeech2" className='add-only' value="6" /> Guilt &nbsp;
                    <input type="radio" id="rbSpeech2_7" name="rbSpeech2" className='add-only' value="7" /> Anhedonia &nbsp;
                    <br />
                    <input type="radio" id="rbSpeech2_8" name="rbSpeech2" className='add-only' value="8" /> Thought Insertion &nbsp;
                    <input type="radio" id="rbSpeech2_9" name="rbSpeech2" className='add-only' value="9" /> Ideas of Reference &nbsp;
                    <input type="radio" id="rbSpeech2_10" name="rbSpeech2" className='add-only' value="10" />Thought Broadcasting
                </p>
                <p>
                    Describe:<textarea id="txtOtherDescribe2" name="txtOtherDescribe2" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Self Abuse</span>
                    <input type="radio" id="rbSpeech3_1" name="rbSpeech3" className='add-only' value="1" /> None Reported &nbsp;
                    <input type="radio" id="rbSpeech3_0" name="rbSpeech3" className='add-only' value="0" /> Self Mutilation &nbsp;
                    <input type="radio" id="rbSpeech3_2" name="rbSpeech3" className='add-only' value="2" /> Suicidal (assess lethality of present) &nbsp;
                    <input type="radio" id="rbSpeech3_3" name="rbSpeech3" className='add-only' value="3" /> Intent &nbsp;
                    <input type="radio" id="rbSpeech3_5" name="rbSpeech3" className='add-only' value="5" /> Plan & Means
                </p>
                <p>
                    <span className='eleHeader'>Aggressive</span>
                    <input type="radio" id="rbSpeech4_1" name="rbSpeech4" className='add-only' value="1" /> None Reported &nbsp;
                    <input type="radio" id="rbSpeech4_0" name="rbSpeech4" className='add-only' value="0" /> Aggressive (assess lethality of present) &nbsp;
                    <input type="radio" id="rbSpeech4_2" name="rbSpeech4" className='add-only' value="2" /> Intent &nbsp;
                    <input type="radio" id="rbSpeech4_3" name="rbSpeech4" className='add-only' value="3" /> Plan
                </p>
                <h3>PERCEPTION
                </h3>
                <p>
                    <span className='eleHeader'>Hallucinations</span>
                    <input type="radio" id="rbSpeech11_1" name="rbSpeech11" className='add-only' value="1" /> None Reported &nbsp;
                    <input type="radio" id="rbSpeech11_0" name="rbSpeech11" className='add-only' value="0" /> Auditory &nbsp;
                    <input type="radio" id="rbSpeech11_2" name="rbSpeech11" className='add-only' value="2" /> Visual &nbsp;
                    <input type="radio" id="rbSpeech11_3" name="rbSpeech11" className='add-only' value="3" /> Olfactory &nbsp;
                    <input type="radio" id="rbSpeech11_5" name="rbSpeech11" className='add-only' value="5" /> Gustatory &nbsp;
                    <input type="radio" id="rbSpeech11_6" name="rbSpeech11" className='add-only' value="6" /> Tactile
                </p>
                <p>
                    Describe:<textarea id="txtOtherDescribe4" name="txtOtherDescribe4" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Other</span>
                    <input type="radio" id="rbSpeech5_1" name="rbSpeech5" className='add-only' value="1" /> None Reported &nbsp;
                    <input type="radio" id="rbSpeech5_0" name="rbSpeech5" className='add-only' value="0" /> Illusions &nbsp;
                    <input type="radio" id="rbSpeech5_2" name="rbSpeech5" className='add-only' value="2" /> Depersonalization &nbsp;
                    <input type="radio" id="rbSpeech5_3" name="rbSpeech5" className='add-only' value="3" /> Derealization
                </p>
                <p>
                    <span className='eleHeader'>MOOD</span>
                    <input type="radio" id="rbSpeech6_1" name="rbSpeech6" className='add-only' value="1" /> Euthymic &nbsp;
                    <input type="radio" id="rbSpeech6_0" name="rbSpeech6" className='add-only' value="0" /> Depressed &nbsp;
                    <input type="radio" id="rbSpeech6_2" name="rbSpeech6" className='add-only' value="2" /> Anxious &nbsp;
                    <input type="radio" id="rbSpeech6_3" name="rbSpeech6" className='add-only' value="3" /> Angry &nbsp;
                    <input type="radio" id="rbSpeech6_5" name="rbSpeech6" className='add-only' value="5" /> Euphoric &nbsp;
                    <input type="radio" id="rbSpeech6_6" name="rbSpeech6" className='add-only' value="6" /> Irritable
                </p>
                <p>
                    <span className='eleHeader'>AFFECT</span>
                    <input type="radio" id="rbSpeech7_1" name="rbSpeech7" className='add-only' value="1" /> Flat &nbsp;
                    <input type="radio" id="rbSpeech7_0" name="rbSpeech7" className='add-only' value="0" /> Inappropriate &nbsp;
                    <input type="radio" id="rbSpeech7_2" name="rbSpeech7" className='add-only' value="2" /> Labile &nbsp;
                    <input type="radio" id="rbSpeech7_3" name="rbSpeech7" className='add-only' value="3" /> Blunted &nbsp;
                    <input type="radio" id="rbSpeech7_5" name="rbSpeech7" className='add-only' value="5" /> Congruent with Mood &nbsp;
                    <input type="radio" id="rbSpeech7_6" name="rbSpeech7" className='add-only' value="6" /> Full &nbsp;
                    <input type="radio" id="rbSpeech7_7" name="rbSpeech7" className='add-only' value="7" /> Constricted
                </p>
                <p>
                    <span className='eleHeader'>BEHAVIOR</span>
                    <input type="radio" id="rbSpeech8_1" name="rbSpeech8" className='add-only' value="1" /> No Aggressive Issues &nbsp;
                    <input type="radio" id="rbSpeech8_0" name="rbSpeech8" className='add-only' value="0" /> Assaultive &nbsp;
                    <input type="radio" id="rbSpeech8_2" name="rbSpeech8" className='add-only' value="2" /> Resistant &nbsp;
                    <input type="radio" id="rbSpeech8_3" name="rbSpeech8" className='add-only' value="3" /> Aggressive &nbsp;
                    <input type="radio" id="rbSpeech8_5" name="rbSpeech8" className='add-only' value="5" /> Agitated &nbsp;
                    <input type="radio" id="rbSpeech8_6" name="rbSpeech8" className='add-only' value="6" /> Hyperactive &nbsp;
                    <input type="radio" id="rbSpeech8_7" name="rbSpeech8" className='add-only' value="7" /> Restless &nbsp;
                    <input type="radio" id="rbSpeech8_8" name="rbSpeech8" className='add-only' value="8" /> Sleepy &nbsp;
                    <input type="radio" id="rbSpeech8_9" name="rbSpeech8" className='add-only' value="9" /> Intrusive
                </p>
                <p>
                    <span className='eleHeader'>IMPULSE CONTROL</span>
                    <input type="radio" id="rbSpeech9_1" name="rbSpeech9" className='add-only' value="1" /> Good &nbsp;
                    <input type="radio" id="rbSpeech9_0" name="rbSpeech9" className='add-only' value="0" /> Poor &nbsp;
                    <input type="radio" id="rbSpeech9_2" name="rbSpeech9" className='add-only' value="2" /> Absent
                </p>
                <p>
                    <span className='eleHeader'>INSIGHT</span>
                    <input type="radio" id="rbSpeech110_1" name="rbSpeech110" className='add-only' value="1" /> Good &nbsp;
                    <input type="radio" id="rbSpeech110_0" name="rbSpeech110" className='add-only' value="0" /> Poor &nbsp;
                    <input type="radio" id="rbSpeech110_2" name="rbSpeech110" className='add-only' value="2" /> Absent
                </p>
                <p>
                    <span className='eleHeader'>JUDGEMENT</span>
                    <input type="radio" id="rbSpeech12_1" name="rbSpeech12" className='add-only' value="1" /> Good &nbsp;
                    <input type="radio" id="rbSpeech12_0" name="rbSpeech12" className='add-only' value="0" /> Poor &nbsp;
                    <input type="radio" id="rbSpeech12_2" name="rbSpeech12" className='add-only' value="2" /> Absent
                </p>
                <h3>RISK ASSESSMENT:
                </h3>
                <p>
                    <span className='eleHeader'>Risk to Self</span>
                    <input type="radio" id="rbSpeech13_1" name="rbSpeech13" className='add-only' value="1" /> Low &nbsp;
                    <input type="radio" id="rbSpeech13_0" name="rbSpeech13" className='add-only' value="0" /> Medium &nbsp;
                    <input type="radio" id="rbSpeech13_2" name="rbSpeech13" className='add-only' value="2" /> High &nbsp;
                    <input type="radio" id="rbSpeech13_3" name="rbSpeech13" className='add-only' value="3" /> Chronic
                </p>
                <p>
                    <span className='eleHeader'>Risk to others</span>
                    <input type="radio" id="rbSpeech14_1" name="rbSpeech14" className='add-only' value="1" /> Low &nbsp;
                    <input type="radio" id="rbSpeech14_0" name="rbSpeech14" className='add-only' value="0" /> Medium &nbsp;
                    <input type="radio" id="rbSpeech14_2" name="rbSpeech14" className='add-only' value="2" /> High &nbsp;
                    <input type="radio" id="rbSpeech14_3" name="rbSpeech14" className='add-only' value="3" /> Chronic
                </p>
                <p>
                    <b>Serious current risk of any of the following:</b>
                    (immediate response needed)
                </p>
                <p>
                    <span className='eleHeader'>Abuse or Family Violence</span>
                    <input type="radio" id="rbSpeech15_1" name="rbSpeech15" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbSpeech15_0" name="rbSpeech15" className='add-only' value="0" /> No
                </p>
                <p>
                    <span className='eleHeader'>Psychotic or Psychologically Disabled</span>
                    <input type="radio" id="rbSpeech16_1" name="rbSpeech16" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbSpeech16_0" name="rbSpeech16" className='add-only' value="0" /> No
                </p>
                <p>
                    <span className='eleHeader'>Unlocked Handgun in the home?</span>
                    <input type="radio" id="rbSpeech17_1" name="rbSpeech17" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbSpeech17_0" name="rbSpeech17" className='add-only' value="0" /> No
                </p>
                <p>
                    <span className='eleHeader'>Any other weapons?</span>
                    <input type="radio" id="rbSpeech18_1" name="rbSpeech18" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbSpeech18_0" name="rbSpeech18" className='add-only' value="0" /> No
                </p>
                <p>
                    <b>Plan:</b>
                </p>
                <p>
                    <span className='eleHeader'>Safety Plan Reviewed:</span>
                    <input type="radio" id="rbSpeech19_1" name="rbSpeech19" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbSpeech19_0" name="rbSpeech19" className='add-only' value="0" /> No
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Treatment Acceptance and Resistance</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>&nbsp;
                        </td>
                        <td className='w-50'>
                            <strong>Yes</strong>
                        </td>
                        <td className='w-50'>
                            <strong>No</strong>
                        </td>
                        <td className='w-350'>
                            <strong>Comment:</strong>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Consumer Accepts problem?
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbConsumer_Yes" name="rbConsumer" className='add-only' value="1" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbConsumer_No" name="rbConsumer" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtHomeComment" name="txtHomeComment" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Consumer Recognizes need for treatment?
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbConsumer1_Yes" name="rbConsumer1" className='add-only' value="1" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbConsumer1_No" name="rbConsumer1" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtHomeComment1" name="txtHomeComment1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Consumer minimizes or blames others?
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbConsumer2_Yes" name="rbConsumer2" className='add-only' value="1" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbConsumer2_No" name="rbConsumer2" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtHomeComment2" name="txtHomeComment2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>External Motivation is primary
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbConsumer3_Yes" name="rbConsumer3" className='add-only' value="1" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbConsumer3_No" name="rbConsumer3" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtHomeComment3" name="txtHomeComment3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Initial goals, strengths, needs, abilities, and preferences discussed with Consumer and parent/guardian?
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbConsumer4_Yes" name="rbConsumer4" className='add-only' value="1" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbConsumer4_No" name="rbConsumer4" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtHomeComment4" name="txtHomeComment4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Initial goals signed by Consumer and parent/guardian?
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbConsumer5_Yes" name="rbConsumer5" className='add-only' value="1" />
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbConsumer5_No" name="rbConsumer5" className='add-only' value="0" />
                        </td>
                        <td className='w-350'>
                            <input type="text" id="txtHomeComment5" name="txtHomeComment5" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Narrative Summary and Conclusions:</span>
                    <textarea id="txtOtherNarrative" name="txtOtherNarrative" className='add-only'></textarea>
                </p>
                <p>
                    <input type="checkbox" name="chkDiagnostic" id="chkDiagnostic" className='add-only' value="Adult" /> DIAGNOSTIC IMPRESSIONS:
                    <input type="checkbox" name="chkDiagnostic1" id="chkDiagnostic1" className='add-only' value="Adult" /> DIAGNOSIS:
                    <textarea id="txtDiagnostic" name="txtDiagnostic" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Axis I:</span>
                    <textarea id="txtAxis1" name="txtAxis1" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Axis II:</span>
                    <textarea id="txtAxis2" name="txtAxis2" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Axis III:</span>
                    <textarea id="txtAxis3" name="txtAxis3" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Axis IV:</span>
                    <textarea id="txtAxis4" name="txtAxis4" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Axis V:</span>
                    <textarea id="txtAxis5" name="txtAxis5" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Needs / Recommendations / Comments to Assigned Clinician:</span>
                    <textarea id="txtOtherRecommendations" name="txtOtherRecommendations" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className="signature w-450"> &nbsp;</td>
                        <td className="signature w-300"> &nbsp;</td>
                    </tr>
                    <tr>
                        <td className="small w-450"> (Insert Printed Name of Assessor and Credentials)</td>
                        <td className="small w-300"> Date Signed</td>
                    </tr>
                    <tr>
                        <td className="signature w-450"> &nbsp;</td>
                        <td className="signature w-300"> &nbsp;</td>
                    </tr>
                    <tr>
                        <td className="small w-450"> Supervisor</td>
                        <td className="small w-300"> Date Signed</td>
                    </tr>
                </table>

            </div>
        </form>

    )
} 
